/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  BranchOptions,
  Branding,
  DeleteSuperAdminApiPricingId200,
  DeleteSuperAdminFranchisePartnersId200,
  DeleteSuperAdminFranchisesFranchiseId200,
  DeleteSuperAdminFranchisesFranchiseIdAdminsAdminId200,
  DeleteSuperAdminFranchisesFranchiseIdParams,
  DeleteSuperAdminFranchisesFranchiseIdWireguard200,
  DeleteSuperAdminHardwareId200,
  DeleteSuperAdminInvoicesId200,
  DeleteSuperAdminModuleBillingId200,
  DeleteSuperAdminPackagesPackageId200,
  DeleteSuperAdminPartnersId200,
  DeliverySettings,
  DeliverySettingsRequest,
  FooterSettings,
  FranchiseModulesResponse,
  FranchiseOverridesRequest,
  FranchiseSummary,
  GetApiManifestWebmanifest200,
  GetApiManifestWebmanifestParams,
  GetCentralAuthMe200,
  GetCentralBranchOptionsParams,
  GetCentralBranches200,
  GetCentralBranchesParams,
  GetCentralBrandingParams,
  GetCentralConfig200,
  GetCentralFranchisesDiscover200Item,
  GetMarketing200,
  GetMarketingSlug200,
  GetPartnerAuthMe200,
  GetPartnerMeFranchises200,
  GetPartnerMeInvoices200,
  GetPartnerMeProfitability200,
  GetPartnerMeProfitabilityParams,
  GetSettingsBasic200,
  GetSettingsBilling200,
  GetSettingsDesign200,
  GetSettingsFranchise200,
  GetSettingsHourlyRates200,
  GetSettingsLunch200,
  GetSettingsLunchPublic200,
  GetSettingsLunchPublicParams,
  GetSettingsOpeningHours200,
  GetSettingsPizzaConfig200,
  GetSettingsSocial200,
  GetSettingsSystem200,
  GetSuperAdminAdmins200Item,
  GetSuperAdminApiPricing200,
  GetSuperAdminAuditLog200,
  GetSuperAdminAuditLogParams,
  GetSuperAdminCardpayDaily200,
  GetSuperAdminCardpayDailyParams,
  GetSuperAdminFranchises200,
  GetSuperAdminFranchisesFranchiseIdDomainsPlan200,
  GetSuperAdminFranchisesFranchiseIdEffectiveModules200,
  GetSuperAdminFranchisesFranchiseIdHardware200,
  GetSuperAdminFranchisesFranchiseIdIntegrations200,
  GetSuperAdminFranchisesFranchiseIdManagerSettings200,
  GetSuperAdminFranchisesFranchiseIdModuleBilling200,
  GetSuperAdminFranchisesFranchiseIdPackage200,
  GetSuperAdminFranchisesFranchiseIdPartners200,
  GetSuperAdminFranchisesFranchiseIdUsage200,
  GetSuperAdminFranchisesFranchiseIdUsageParams,
  GetSuperAdminInvoices200,
  GetSuperAdminMarketingPages200,
  GetSuperAdminMarketingPagesSlug200,
  GetSuperAdminModules200,
  GetSuperAdminModulesCatalog200,
  GetSuperAdminPackages200,
  GetSuperAdminPartners200,
  GetSuperAdminPlatformBilling200,
  GetSuperAdminProfitability200,
  GetSuperAdminProfitabilityParams,
  GetSuperAdminStatsFranchises200,
  GetSuperAdminStatsPlatform200,
  GetSuperAdminUsagePlatform200,
  GetSuperAdminUsagePlatformParams,
  IntegrationSettings,
  PackageModulesRequest,
  PackageReorderRequest,
  PatchSuperAdminApiPricingId200,
  PatchSuperAdminApiPricingIdBody,
  PatchSuperAdminFranchisesFranchiseId200,
  PatchSuperAdminFranchisesFranchiseIdAdminsAdminId200,
  PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody,
  PatchSuperAdminFranchisesFranchiseIdBody,
  PatchSuperAdminFranchisesFranchiseIdIntegrations200,
  PatchSuperAdminFranchisesFranchiseIdIntegrationsBody,
  PatchSuperAdminFranchisesFranchiseIdManagerSettings200,
  PatchSuperAdminFranchisesFranchiseIdManagerSettingsBody,
  PatchSuperAdminHardwareId200,
  PatchSuperAdminHardwareIdBody,
  PatchSuperAdminInvoicesId200,
  PatchSuperAdminInvoicesIdBody,
  PatchSuperAdminModuleBillingId200,
  PatchSuperAdminModuleBillingIdBody,
  PatchSuperAdminPackagesPackageId200,
  PatchSuperAdminPackagesPackageIdBody,
  PatchSuperAdminPartnersId200,
  PatchSuperAdminPartnersIdBody,
  PostCentralAuthLogin200,
  PostCentralFranchisesCacheInvalidate200,
  PostCentralFranchisesCacheInvalidateBody,
  PostPartnerAuthLogin200,
  PostPartnerAuthLoginBody,
  PostSuperAdminApiPricing200,
  PostSuperAdminApiPricingBody,
  PostSuperAdminBillingRun200,
  PostSuperAdminBillingRunBody,
  PostSuperAdminFranchises200,
  PostSuperAdminFranchisesBody,
  PostSuperAdminFranchisesFranchiseIdDomainsProvision200,
  PostSuperAdminFranchisesFranchiseIdHardware200,
  PostSuperAdminFranchisesFranchiseIdHardwareBody,
  PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId200,
  PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody,
  PostSuperAdminFranchisesFranchiseIdModuleBilling200,
  PostSuperAdminFranchisesFranchiseIdModuleBillingBody,
  PostSuperAdminFranchisesFranchiseIdPartners200,
  PostSuperAdminFranchisesFranchiseIdPartnersBody,
  PostSuperAdminFranchisesFranchiseIdRestoreDatabase200,
  PostSuperAdminFranchisesFranchiseIdRestoreDatabaseBody,
  PostSuperAdminFranchisesFranchiseIdRestoreDatabaseParams,
  PostSuperAdminFranchisesFranchiseIdSsoToken200,
  PostSuperAdminFranchisesFranchiseIdWireguardProvision200,
  PostSuperAdminInvoices200,
  PostSuperAdminInvoicesBody,
  PostSuperAdminInvoicesIdResend200,
  PostSuperAdminInvoicesIdResendBody,
  PostSuperAdminMarketingPagesSlugDomain200,
  PostSuperAdminMarketingPagesSlugDomainBody,
  PostSuperAdminMarketingPagesSlugPublish200,
  PostSuperAdminPackages200,
  PostSuperAdminPackagesBody,
  PostSuperAdminPackagesReorder200,
  PostSuperAdminPartners200,
  PostSuperAdminPartnersBody,
  PublicGeneralSettings,
  PublicLanguageSettings,
  PutSettingsBasic200,
  PutSettingsBasicBody,
  PutSettingsBilling200,
  PutSettingsBillingBody,
  PutSettingsDesign200,
  PutSettingsDesignBody,
  PutSettingsFranchise200,
  PutSettingsFranchiseBody,
  PutSettingsGeneralBody,
  PutSettingsHourlyRates200,
  PutSettingsHourlyRatesBody,
  PutSettingsIntegrationsBody,
  PutSettingsLunch200,
  PutSettingsLunchBody,
  PutSettingsOpeningHours200,
  PutSettingsOpeningHoursBody,
  PutSettingsPizzaConfig200,
  PutSettingsPizzaConfigBody,
  PutSettingsSocial200,
  PutSettingsSocialBody,
  PutSettingsSystem200,
  PutSettingsSystemBody,
  PutSuperAdminFranchisesFranchiseIdOverrides200,
  PutSuperAdminFranchisesFranchiseIdPackage200,
  PutSuperAdminFranchisesFranchiseIdPackageBody,
  PutSuperAdminMarketingPagesSlug200,
  PutSuperAdminMarketingPagesSlugBody,
  PutSuperAdminPackagesPackageIdModules200,
  PutSuperAdminPartnersIdLogin200,
  PutSuperAdminPartnersIdLoginBody,
  PutSuperAdminPlatformBilling200,
  PutSuperAdminPlatformBillingBody,
  SuperAdminLoginRequest,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getGetSuperAdminPlatformBillingUrl = () => {
  return `/api/v1/super-admin/platform-billing`
}

/**
 * @summary The supplier block that appears on every invoice
 */
export const getSuperAdminPlatformBilling = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminPlatformBilling200> => {
  return customFetch<GetSuperAdminPlatformBilling200>(getGetSuperAdminPlatformBillingUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminPlatformBillingQueryKey = () => {
  return [`/api/v1/super-admin/platform-billing`] as const
}

export const getGetSuperAdminPlatformBillingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminPlatformBillingQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>> = ({
    signal,
  }) => getSuperAdminPlatformBilling({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminPlatformBillingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>
>
export type GetSuperAdminPlatformBillingQueryError = unknown

export function useGetSuperAdminPlatformBilling<
  TData = Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminPlatformBilling<
  TData = Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminPlatformBilling<
  TData = Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The supplier block that appears on every invoice
 */

export function useGetSuperAdminPlatformBilling<
  TData = Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPlatformBilling>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminPlatformBillingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSuperAdminPlatformBillingUrl = () => {
  return `/api/v1/super-admin/platform-billing`
}

/**
 * @summary Update the supplier block
 */
export const putSuperAdminPlatformBilling = async (
  putSuperAdminPlatformBillingBody?: PutSuperAdminPlatformBillingBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSuperAdminPlatformBilling200> => {
  return customFetch<PutSuperAdminPlatformBilling200>(getPutSuperAdminPlatformBillingUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSuperAdminPlatformBillingBody),
  })
}

export const getPutSuperAdminPlatformBillingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSuperAdminPlatformBilling>>,
    TError,
    { data?: PutSuperAdminPlatformBillingBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSuperAdminPlatformBilling>>,
  TError,
  { data?: PutSuperAdminPlatformBillingBody },
  TContext
> => {
  const mutationKey = ['putSuperAdminPlatformBilling']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSuperAdminPlatformBilling>>,
    { data?: PutSuperAdminPlatformBillingBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSuperAdminPlatformBilling(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSuperAdminPlatformBillingMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSuperAdminPlatformBilling>>
>
export type PutSuperAdminPlatformBillingMutationBody = PutSuperAdminPlatformBillingBody | undefined
export type PutSuperAdminPlatformBillingMutationError = unknown

/**
 * @summary Update the supplier block
 */
export const usePutSuperAdminPlatformBilling = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSuperAdminPlatformBilling>>,
      TError,
      { data?: PutSuperAdminPlatformBillingBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSuperAdminPlatformBilling>>,
  TError,
  { data?: PutSuperAdminPlatformBillingBody },
  TContext
> => {
  return useMutation(getPutSuperAdminPlatformBillingMutationOptions(options), queryClient)
}
export const getPutSuperAdminPartnersIdLoginUrl = (id: number) => {
  return `/api/v1/super-admin/partners/${id}/login`
}

/**
 * @summary Grant, change or withdraw a partner's portal sign-in
 */
export const putSuperAdminPartnersIdLogin = async (
  id: number,
  putSuperAdminPartnersIdLoginBody?: PutSuperAdminPartnersIdLoginBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSuperAdminPartnersIdLogin200> => {
  return customFetch<PutSuperAdminPartnersIdLogin200>(getPutSuperAdminPartnersIdLoginUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSuperAdminPartnersIdLoginBody),
  })
}

export const getPutSuperAdminPartnersIdLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSuperAdminPartnersIdLogin>>,
    TError,
    { id: number; data?: PutSuperAdminPartnersIdLoginBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSuperAdminPartnersIdLogin>>,
  TError,
  { id: number; data?: PutSuperAdminPartnersIdLoginBody },
  TContext
> => {
  const mutationKey = ['putSuperAdminPartnersIdLogin']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSuperAdminPartnersIdLogin>>,
    { id: number; data?: PutSuperAdminPartnersIdLoginBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return putSuperAdminPartnersIdLogin(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSuperAdminPartnersIdLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSuperAdminPartnersIdLogin>>
>
export type PutSuperAdminPartnersIdLoginMutationBody = PutSuperAdminPartnersIdLoginBody | undefined
export type PutSuperAdminPartnersIdLoginMutationError = unknown

/**
 * @summary Grant, change or withdraw a partner's portal sign-in
 */
export const usePutSuperAdminPartnersIdLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSuperAdminPartnersIdLogin>>,
      TError,
      { id: number; data?: PutSuperAdminPartnersIdLoginBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSuperAdminPartnersIdLogin>>,
  TError,
  { id: number; data?: PutSuperAdminPartnersIdLoginBody },
  TContext
> => {
  return useMutation(getPutSuperAdminPartnersIdLoginMutationOptions(options), queryClient)
}
export const getPutSuperAdminPackagesPackageIdModulesUrl = (packageId: number) => {
  return `/api/v1/super-admin/packages/${packageId}/modules`
}

/**
 * @summary Replace the features a tier carries
 */
export const putSuperAdminPackagesPackageIdModules = async (
  packageId: number,
  packageModulesRequest: PackageModulesRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSuperAdminPackagesPackageIdModules200> => {
  return customFetch<PutSuperAdminPackagesPackageIdModules200>(
    getPutSuperAdminPackagesPackageIdModulesUrl(packageId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(packageModulesRequest),
    },
  )
}

export const getPutSuperAdminPackagesPackageIdModulesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSuperAdminPackagesPackageIdModules>>,
    TError,
    { packageId: number; data: PackageModulesRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSuperAdminPackagesPackageIdModules>>,
  TError,
  { packageId: number; data: PackageModulesRequest },
  TContext
> => {
  const mutationKey = ['putSuperAdminPackagesPackageIdModules']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSuperAdminPackagesPackageIdModules>>,
    { packageId: number; data: PackageModulesRequest }
  > = (props) => {
    const { packageId, data } = props ?? {}

    return putSuperAdminPackagesPackageIdModules(packageId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSuperAdminPackagesPackageIdModulesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSuperAdminPackagesPackageIdModules>>
>
export type PutSuperAdminPackagesPackageIdModulesMutationBody = PackageModulesRequest
export type PutSuperAdminPackagesPackageIdModulesMutationError = unknown

/**
 * @summary Replace the features a tier carries
 */
export const usePutSuperAdminPackagesPackageIdModules = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSuperAdminPackagesPackageIdModules>>,
      TError,
      { packageId: number; data: PackageModulesRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSuperAdminPackagesPackageIdModules>>,
  TError,
  { packageId: number; data: PackageModulesRequest },
  TContext
> => {
  return useMutation(getPutSuperAdminPackagesPackageIdModulesMutationOptions(options), queryClient)
}
export const getGetSuperAdminMarketingPagesSlugUrl = (slug: string) => {
  return `/api/v1/super-admin/marketing-pages/${slug}`
}

/**
 * @summary One marketing page, as the editor sees it
 */
export const getSuperAdminMarketingPagesSlug = async (
  slug: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminMarketingPagesSlug200> => {
  return customFetch<GetSuperAdminMarketingPagesSlug200>(
    getGetSuperAdminMarketingPagesSlugUrl(slug),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminMarketingPagesSlugQueryKey = (slug: string) => {
  return [`/api/v1/super-admin/marketing-pages/${slug}`] as const
}

export const getGetSuperAdminMarketingPagesSlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminMarketingPagesSlugQueryKey(slug)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>> = ({
    signal,
  }) => getSuperAdminMarketingPagesSlug(slug, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminMarketingPagesSlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>
>
export type GetSuperAdminMarketingPagesSlugQueryError = unknown

export function useGetSuperAdminMarketingPagesSlug<
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminMarketingPagesSlug<
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminMarketingPagesSlug<
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One marketing page, as the editor sees it
 */

export function useGetSuperAdminMarketingPagesSlug<
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPagesSlug>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminMarketingPagesSlugQueryOptions(slug, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSuperAdminMarketingPagesSlugUrl = (slug: string) => {
  return `/api/v1/super-admin/marketing-pages/${slug}`
}

/**
 * @summary Save a marketing page into its draft
 */
export const putSuperAdminMarketingPagesSlug = async (
  slug: string,
  putSuperAdminMarketingPagesSlugBody?: PutSuperAdminMarketingPagesSlugBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSuperAdminMarketingPagesSlug200> => {
  return customFetch<PutSuperAdminMarketingPagesSlug200>(
    getPutSuperAdminMarketingPagesSlugUrl(slug),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(putSuperAdminMarketingPagesSlugBody),
    },
  )
}

export const getPutSuperAdminMarketingPagesSlugMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSuperAdminMarketingPagesSlug>>,
    TError,
    { slug: string; data?: PutSuperAdminMarketingPagesSlugBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSuperAdminMarketingPagesSlug>>,
  TError,
  { slug: string; data?: PutSuperAdminMarketingPagesSlugBody },
  TContext
> => {
  const mutationKey = ['putSuperAdminMarketingPagesSlug']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSuperAdminMarketingPagesSlug>>,
    { slug: string; data?: PutSuperAdminMarketingPagesSlugBody }
  > = (props) => {
    const { slug, data } = props ?? {}

    return putSuperAdminMarketingPagesSlug(slug, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSuperAdminMarketingPagesSlugMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSuperAdminMarketingPagesSlug>>
>
export type PutSuperAdminMarketingPagesSlugMutationBody =
  PutSuperAdminMarketingPagesSlugBody | undefined
export type PutSuperAdminMarketingPagesSlugMutationError = unknown

/**
 * @summary Save a marketing page into its draft
 */
export const usePutSuperAdminMarketingPagesSlug = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSuperAdminMarketingPagesSlug>>,
      TError,
      { slug: string; data?: PutSuperAdminMarketingPagesSlugBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSuperAdminMarketingPagesSlug>>,
  TError,
  { slug: string; data?: PutSuperAdminMarketingPagesSlugBody },
  TContext
> => {
  return useMutation(getPutSuperAdminMarketingPagesSlugMutationOptions(options), queryClient)
}
export const getGetSuperAdminFranchisesFranchiseIdPackageUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/package`
}

/**
 * @summary The tier a franchise is on, and what was negotiated on top
 */
export const getSuperAdminFranchisesFranchiseIdPackage = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdPackage200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdPackage200>(
    getGetSuperAdminFranchisesFranchiseIdPackageUrl(franchiseId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdPackageQueryKey = (franchiseId: number) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/package`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdPackageQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSuperAdminFranchisesFranchiseIdPackageQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdPackage(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdPackageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>
>
export type GetSuperAdminFranchisesFranchiseIdPackageQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdPackage<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdPackage<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdPackage<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The tier a franchise is on, and what was negotiated on top
 */

export function useGetSuperAdminFranchisesFranchiseIdPackage<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPackage>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdPackageQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSuperAdminFranchisesFranchiseIdPackageUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/package`
}

/**
 * @summary Move a franchise onto a tier
 */
export const putSuperAdminFranchisesFranchiseIdPackage = async (
  franchiseId: number,
  putSuperAdminFranchisesFranchiseIdPackageBody: PutSuperAdminFranchisesFranchiseIdPackageBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSuperAdminFranchisesFranchiseIdPackage200> => {
  return customFetch<PutSuperAdminFranchisesFranchiseIdPackage200>(
    getPutSuperAdminFranchisesFranchiseIdPackageUrl(franchiseId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(putSuperAdminFranchisesFranchiseIdPackageBody),
    },
  )
}

export const getPutSuperAdminFranchisesFranchiseIdPackageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdPackage>>,
    TError,
    { franchiseId: number; data: PutSuperAdminFranchisesFranchiseIdPackageBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdPackage>>,
  TError,
  { franchiseId: number; data: PutSuperAdminFranchisesFranchiseIdPackageBody },
  TContext
> => {
  const mutationKey = ['putSuperAdminFranchisesFranchiseIdPackage']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdPackage>>,
    { franchiseId: number; data: PutSuperAdminFranchisesFranchiseIdPackageBody }
  > = (props) => {
    const { franchiseId, data } = props ?? {}

    return putSuperAdminFranchisesFranchiseIdPackage(franchiseId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSuperAdminFranchisesFranchiseIdPackageMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdPackage>>
>
export type PutSuperAdminFranchisesFranchiseIdPackageMutationBody =
  PutSuperAdminFranchisesFranchiseIdPackageBody
export type PutSuperAdminFranchisesFranchiseIdPackageMutationError = unknown

/**
 * @summary Move a franchise onto a tier
 */
export const usePutSuperAdminFranchisesFranchiseIdPackage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdPackage>>,
      TError,
      { franchiseId: number; data: PutSuperAdminFranchisesFranchiseIdPackageBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdPackage>>,
  TError,
  { franchiseId: number; data: PutSuperAdminFranchisesFranchiseIdPackageBody },
  TContext
> => {
  return useMutation(
    getPutSuperAdminFranchisesFranchiseIdPackageMutationOptions(options),
    queryClient,
  )
}
export const getPutSuperAdminFranchisesFranchiseIdOverridesUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/overrides`
}

/**
 * @summary Replace a franchise's per-feature grants and revokes
 */
export const putSuperAdminFranchisesFranchiseIdOverrides = async (
  franchiseId: number,
  franchiseOverridesRequest: FranchiseOverridesRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSuperAdminFranchisesFranchiseIdOverrides200> => {
  return customFetch<PutSuperAdminFranchisesFranchiseIdOverrides200>(
    getPutSuperAdminFranchisesFranchiseIdOverridesUrl(franchiseId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(franchiseOverridesRequest),
    },
  )
}

export const getPutSuperAdminFranchisesFranchiseIdOverridesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdOverrides>>,
    TError,
    { franchiseId: number; data: FranchiseOverridesRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdOverrides>>,
  TError,
  { franchiseId: number; data: FranchiseOverridesRequest },
  TContext
> => {
  const mutationKey = ['putSuperAdminFranchisesFranchiseIdOverrides']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdOverrides>>,
    { franchiseId: number; data: FranchiseOverridesRequest }
  > = (props) => {
    const { franchiseId, data } = props ?? {}

    return putSuperAdminFranchisesFranchiseIdOverrides(franchiseId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSuperAdminFranchisesFranchiseIdOverridesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdOverrides>>
>
export type PutSuperAdminFranchisesFranchiseIdOverridesMutationBody = FranchiseOverridesRequest
export type PutSuperAdminFranchisesFranchiseIdOverridesMutationError = unknown

/**
 * @summary Replace a franchise's per-feature grants and revokes
 */
export const usePutSuperAdminFranchisesFranchiseIdOverrides = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdOverrides>>,
      TError,
      { franchiseId: number; data: FranchiseOverridesRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSuperAdminFranchisesFranchiseIdOverrides>>,
  TError,
  { franchiseId: number; data: FranchiseOverridesRequest },
  TContext
> => {
  return useMutation(
    getPutSuperAdminFranchisesFranchiseIdOverridesMutationOptions(options),
    queryClient,
  )
}
export const getGetSettingsSystemUrl = () => {
  return `/api/v1/settings/system`
}

/**
 * @summary The system settings
 */
export const getSettingsSystem = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsSystem200> => {
  return customFetch<GetSettingsSystem200>(getGetSettingsSystemUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsSystemQueryKey = () => {
  return [`/api/v1/settings/system`] as const
}

export const getGetSettingsSystemQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsSystem>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSystem>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsSystemQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsSystem>>> = ({ signal }) =>
    getSettingsSystem({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsSystem>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsSystemQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsSystem>>
>
export type GetSettingsSystemQueryError = unknown

export function useGetSettingsSystem<
  TData = Awaited<ReturnType<typeof getSettingsSystem>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSystem>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSystem>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSystem>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSystem<
  TData = Awaited<ReturnType<typeof getSettingsSystem>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSystem>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSystem>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSystem>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSystem<
  TData = Awaited<ReturnType<typeof getSettingsSystem>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSystem>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The system settings
 */

export function useGetSettingsSystem<
  TData = Awaited<ReturnType<typeof getSettingsSystem>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSystem>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsSystemQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsSystemUrl = () => {
  return `/api/v1/settings/system`
}

/**
 * @summary Change the system settings
 */
export const putSettingsSystem = async (
  putSettingsSystemBody: PutSettingsSystemBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsSystem200> => {
  return customFetch<PutSettingsSystem200>(getPutSettingsSystemUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsSystemBody),
  })
}

export const getPutSettingsSystemMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsSystem>>,
    TError,
    { data: PutSettingsSystemBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsSystem>>,
  TError,
  { data: PutSettingsSystemBody },
  TContext
> => {
  const mutationKey = ['putSettingsSystem']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsSystem>>,
    { data: PutSettingsSystemBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsSystem(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsSystemMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsSystem>>
>
export type PutSettingsSystemMutationBody = PutSettingsSystemBody
export type PutSettingsSystemMutationError = unknown

/**
 * @summary Change the system settings
 */
export const usePutSettingsSystem = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsSystem>>,
      TError,
      { data: PutSettingsSystemBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsSystem>>,
  TError,
  { data: PutSettingsSystemBody },
  TContext
> => {
  return useMutation(getPutSettingsSystemMutationOptions(options), queryClient)
}
export const getGetSettingsSocialUrl = () => {
  return `/api/v1/settings/social`
}

/**
 * @summary The social links
 */
export const getSettingsSocial = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsSocial200> => {
  return customFetch<GetSettingsSocial200>(getGetSettingsSocialUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsSocialQueryKey = () => {
  return [`/api/v1/settings/social`] as const
}

export const getGetSettingsSocialQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsSocial>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSocial>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsSocialQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsSocial>>> = ({ signal }) =>
    getSettingsSocial({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsSocial>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsSocialQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsSocial>>
>
export type GetSettingsSocialQueryError = unknown

export function useGetSettingsSocial<
  TData = Awaited<ReturnType<typeof getSettingsSocial>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSocial>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSocial>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSocial>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSocial<
  TData = Awaited<ReturnType<typeof getSettingsSocial>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSocial>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSocial>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSocial>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSocial<
  TData = Awaited<ReturnType<typeof getSettingsSocial>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSocial>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The social links
 */

export function useGetSettingsSocial<
  TData = Awaited<ReturnType<typeof getSettingsSocial>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSocial>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsSocialQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsSocialUrl = () => {
  return `/api/v1/settings/social`
}

/**
 * Replaces the section rather than merging it, so send every field. A body that omits a key currently holding a value is refused, naming it - several of these are served unauthenticated by `GET /settings/footer`, so a partial save changes a public page. An explicit empty string still clears a field.
 * @summary Change the social links
 */
export const putSettingsSocial = async (
  putSettingsSocialBody: PutSettingsSocialBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsSocial200> => {
  return customFetch<PutSettingsSocial200>(getPutSettingsSocialUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsSocialBody),
  })
}

export const getPutSettingsSocialMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsSocial>>,
    TError,
    { data: PutSettingsSocialBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsSocial>>,
  TError,
  { data: PutSettingsSocialBody },
  TContext
> => {
  const mutationKey = ['putSettingsSocial']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsSocial>>,
    { data: PutSettingsSocialBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsSocial(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsSocialMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsSocial>>
>
export type PutSettingsSocialMutationBody = PutSettingsSocialBody
export type PutSettingsSocialMutationError = unknown

/**
 * @summary Change the social links
 */
export const usePutSettingsSocial = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsSocial>>,
      TError,
      { data: PutSettingsSocialBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsSocial>>,
  TError,
  { data: PutSettingsSocialBody },
  TContext
> => {
  return useMutation(getPutSettingsSocialMutationOptions(options), queryClient)
}
export const getGetSettingsPizzaConfigUrl = () => {
  return `/api/v1/settings/pizza-config`
}

/**
 * @summary How a pizza is sized and priced
 */
export const getSettingsPizzaConfig = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsPizzaConfig200> => {
  return customFetch<GetSettingsPizzaConfig200>(getGetSettingsPizzaConfigUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsPizzaConfigQueryKey = () => {
  return [`/api/v1/settings/pizza-config`] as const
}

export const getGetSettingsPizzaConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsPizzaConfig>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsPizzaConfig>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsPizzaConfigQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsPizzaConfig>>> = ({ signal }) =>
    getSettingsPizzaConfig({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsPizzaConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsPizzaConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsPizzaConfig>>
>
export type GetSettingsPizzaConfigQueryError = unknown

export function useGetSettingsPizzaConfig<
  TData = Awaited<ReturnType<typeof getSettingsPizzaConfig>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPizzaConfig>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPizzaConfig>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPizzaConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPizzaConfig<
  TData = Awaited<ReturnType<typeof getSettingsPizzaConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPizzaConfig>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPizzaConfig>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPizzaConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPizzaConfig<
  TData = Awaited<ReturnType<typeof getSettingsPizzaConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPizzaConfig>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How a pizza is sized and priced
 */

export function useGetSettingsPizzaConfig<
  TData = Awaited<ReturnType<typeof getSettingsPizzaConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPizzaConfig>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsPizzaConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsPizzaConfigUrl = () => {
  return `/api/v1/settings/pizza-config`
}

/**
 * @summary Change how a pizza is sized and priced
 */
export const putSettingsPizzaConfig = async (
  putSettingsPizzaConfigBody: PutSettingsPizzaConfigBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsPizzaConfig200> => {
  return customFetch<PutSettingsPizzaConfig200>(getPutSettingsPizzaConfigUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsPizzaConfigBody),
  })
}

export const getPutSettingsPizzaConfigMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsPizzaConfig>>,
    TError,
    { data: PutSettingsPizzaConfigBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsPizzaConfig>>,
  TError,
  { data: PutSettingsPizzaConfigBody },
  TContext
> => {
  const mutationKey = ['putSettingsPizzaConfig']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsPizzaConfig>>,
    { data: PutSettingsPizzaConfigBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsPizzaConfig(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsPizzaConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsPizzaConfig>>
>
export type PutSettingsPizzaConfigMutationBody = PutSettingsPizzaConfigBody
export type PutSettingsPizzaConfigMutationError = unknown

/**
 * @summary Change how a pizza is sized and priced
 */
export const usePutSettingsPizzaConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsPizzaConfig>>,
      TError,
      { data: PutSettingsPizzaConfigBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsPizzaConfig>>,
  TError,
  { data: PutSettingsPizzaConfigBody },
  TContext
> => {
  return useMutation(getPutSettingsPizzaConfigMutationOptions(options), queryClient)
}
export const getGetSettingsOpeningHoursUrl = () => {
  return `/api/v1/settings/opening-hours`
}

/**
 * @summary The opening hours
 */
export const getSettingsOpeningHours = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsOpeningHours200> => {
  return customFetch<GetSettingsOpeningHours200>(getGetSettingsOpeningHoursUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsOpeningHoursQueryKey = () => {
  return [`/api/v1/settings/opening-hours`] as const
}

export const getGetSettingsOpeningHoursQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsOpeningHours>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsOpeningHours>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsOpeningHoursQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsOpeningHours>>> = ({
    signal,
  }) => getSettingsOpeningHours({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsOpeningHours>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsOpeningHoursQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsOpeningHours>>
>
export type GetSettingsOpeningHoursQueryError = unknown

export function useGetSettingsOpeningHours<
  TData = Awaited<ReturnType<typeof getSettingsOpeningHours>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsOpeningHours>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsOpeningHours>>,
          TError,
          Awaited<ReturnType<typeof getSettingsOpeningHours>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsOpeningHours<
  TData = Awaited<ReturnType<typeof getSettingsOpeningHours>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsOpeningHours>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsOpeningHours>>,
          TError,
          Awaited<ReturnType<typeof getSettingsOpeningHours>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsOpeningHours<
  TData = Awaited<ReturnType<typeof getSettingsOpeningHours>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsOpeningHours>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The opening hours
 */

export function useGetSettingsOpeningHours<
  TData = Awaited<ReturnType<typeof getSettingsOpeningHours>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsOpeningHours>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsOpeningHoursQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsOpeningHoursUrl = () => {
  return `/api/v1/settings/opening-hours`
}

/**
 * @summary Change the opening hours
 */
export const putSettingsOpeningHours = async (
  putSettingsOpeningHoursBody: PutSettingsOpeningHoursBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsOpeningHours200> => {
  return customFetch<PutSettingsOpeningHours200>(getPutSettingsOpeningHoursUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsOpeningHoursBody),
  })
}

export const getPutSettingsOpeningHoursMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsOpeningHours>>,
    TError,
    { data: PutSettingsOpeningHoursBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsOpeningHours>>,
  TError,
  { data: PutSettingsOpeningHoursBody },
  TContext
> => {
  const mutationKey = ['putSettingsOpeningHours']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsOpeningHours>>,
    { data: PutSettingsOpeningHoursBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsOpeningHours(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsOpeningHoursMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsOpeningHours>>
>
export type PutSettingsOpeningHoursMutationBody = PutSettingsOpeningHoursBody
export type PutSettingsOpeningHoursMutationError = unknown

/**
 * @summary Change the opening hours
 */
export const usePutSettingsOpeningHours = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsOpeningHours>>,
      TError,
      { data: PutSettingsOpeningHoursBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsOpeningHours>>,
  TError,
  { data: PutSettingsOpeningHoursBody },
  TContext
> => {
  return useMutation(getPutSettingsOpeningHoursMutationOptions(options), queryClient)
}
export const getGetSettingsLunchUrl = () => {
  return `/api/v1/settings/lunch`
}

/**
 * @summary The lunch menu
 */
export const getSettingsLunch = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsLunch200> => {
  return customFetch<GetSettingsLunch200>(getGetSettingsLunchUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsLunchQueryKey = () => {
  return [`/api/v1/settings/lunch`] as const
}

export const getGetSettingsLunchQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsLunch>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunch>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsLunchQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsLunch>>> = ({ signal }) =>
    getSettingsLunch({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsLunch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsLunchQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsLunch>>>
export type GetSettingsLunchQueryError = unknown

export function useGetSettingsLunch<
  TData = Awaited<ReturnType<typeof getSettingsLunch>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunch>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsLunch>>,
          TError,
          Awaited<ReturnType<typeof getSettingsLunch>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsLunch<
  TData = Awaited<ReturnType<typeof getSettingsLunch>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunch>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsLunch>>,
          TError,
          Awaited<ReturnType<typeof getSettingsLunch>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsLunch<
  TData = Awaited<ReturnType<typeof getSettingsLunch>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunch>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The lunch menu
 */

export function useGetSettingsLunch<
  TData = Awaited<ReturnType<typeof getSettingsLunch>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunch>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsLunchQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsLunchUrl = () => {
  return `/api/v1/settings/lunch`
}

/**
 * @summary Change the lunch menu
 */
export const putSettingsLunch = async (
  putSettingsLunchBody: PutSettingsLunchBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsLunch200> => {
  return customFetch<PutSettingsLunch200>(getPutSettingsLunchUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsLunchBody),
  })
}

export const getPutSettingsLunchMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsLunch>>,
    TError,
    { data: PutSettingsLunchBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsLunch>>,
  TError,
  { data: PutSettingsLunchBody },
  TContext
> => {
  const mutationKey = ['putSettingsLunch']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsLunch>>,
    { data: PutSettingsLunchBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsLunch(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsLunchMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsLunch>>
>
export type PutSettingsLunchMutationBody = PutSettingsLunchBody
export type PutSettingsLunchMutationError = unknown

/**
 * @summary Change the lunch menu
 */
export const usePutSettingsLunch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsLunch>>,
      TError,
      { data: PutSettingsLunchBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsLunch>>,
  TError,
  { data: PutSettingsLunchBody },
  TContext
> => {
  return useMutation(getPutSettingsLunchMutationOptions(options), queryClient)
}
export const getGetSettingsIntegrationsUrl = () => {
  return `/api/v1/settings/integrations`
}

/**
 * @summary The delivery-platform integrations, without their keys
 */
export const getSettingsIntegrations = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<IntegrationSettings> => {
  return customFetch<IntegrationSettings>(getGetSettingsIntegrationsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsIntegrationsQueryKey = () => {
  return [`/api/v1/settings/integrations`] as const
}

export const getGetSettingsIntegrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsIntegrations>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsIntegrations>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsIntegrationsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsIntegrations>>> = ({
    signal,
  }) => getSettingsIntegrations({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsIntegrations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsIntegrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsIntegrations>>
>
export type GetSettingsIntegrationsQueryError = unknown

export function useGetSettingsIntegrations<
  TData = Awaited<ReturnType<typeof getSettingsIntegrations>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsIntegrations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getSettingsIntegrations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsIntegrations<
  TData = Awaited<ReturnType<typeof getSettingsIntegrations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsIntegrations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getSettingsIntegrations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsIntegrations<
  TData = Awaited<ReturnType<typeof getSettingsIntegrations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsIntegrations>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The delivery-platform integrations, without their keys
 */

export function useGetSettingsIntegrations<
  TData = Awaited<ReturnType<typeof getSettingsIntegrations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsIntegrations>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsIntegrationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsIntegrationsUrl = () => {
  return `/api/v1/settings/integrations`
}

/**
 * @summary Change the delivery-platform integrations
 */
export const putSettingsIntegrations = async (
  putSettingsIntegrationsBody: PutSettingsIntegrationsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<IntegrationSettings> => {
  return customFetch<IntegrationSettings>(getPutSettingsIntegrationsUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsIntegrationsBody),
  })
}

export const getPutSettingsIntegrationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsIntegrations>>,
    TError,
    { data: PutSettingsIntegrationsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsIntegrations>>,
  TError,
  { data: PutSettingsIntegrationsBody },
  TContext
> => {
  const mutationKey = ['putSettingsIntegrations']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsIntegrations>>,
    { data: PutSettingsIntegrationsBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsIntegrations(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsIntegrationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsIntegrations>>
>
export type PutSettingsIntegrationsMutationBody = PutSettingsIntegrationsBody
export type PutSettingsIntegrationsMutationError = unknown

/**
 * @summary Change the delivery-platform integrations
 */
export const usePutSettingsIntegrations = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsIntegrations>>,
      TError,
      { data: PutSettingsIntegrationsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsIntegrations>>,
  TError,
  { data: PutSettingsIntegrationsBody },
  TContext
> => {
  return useMutation(getPutSettingsIntegrationsMutationOptions(options), queryClient)
}
export const getGetSettingsHourlyRatesUrl = () => {
  return `/api/v1/settings/hourly-rates`
}

/**
 * @summary What each employee is paid per hour, keyed by employee id
 */
export const getSettingsHourlyRates = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsHourlyRates200> => {
  return customFetch<GetSettingsHourlyRates200>(getGetSettingsHourlyRatesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsHourlyRatesQueryKey = () => {
  return [`/api/v1/settings/hourly-rates`] as const
}

export const getGetSettingsHourlyRatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsHourlyRates>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsHourlyRates>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsHourlyRatesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsHourlyRates>>> = ({ signal }) =>
    getSettingsHourlyRates({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsHourlyRates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsHourlyRatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsHourlyRates>>
>
export type GetSettingsHourlyRatesQueryError = unknown

export function useGetSettingsHourlyRates<
  TData = Awaited<ReturnType<typeof getSettingsHourlyRates>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsHourlyRates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsHourlyRates>>,
          TError,
          Awaited<ReturnType<typeof getSettingsHourlyRates>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsHourlyRates<
  TData = Awaited<ReturnType<typeof getSettingsHourlyRates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsHourlyRates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsHourlyRates>>,
          TError,
          Awaited<ReturnType<typeof getSettingsHourlyRates>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsHourlyRates<
  TData = Awaited<ReturnType<typeof getSettingsHourlyRates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsHourlyRates>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What each employee is paid per hour, keyed by employee id
 */

export function useGetSettingsHourlyRates<
  TData = Awaited<ReturnType<typeof getSettingsHourlyRates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsHourlyRates>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsHourlyRatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsHourlyRatesUrl = () => {
  return `/api/v1/settings/hourly-rates`
}

/**
 * @summary Change what each employee is paid per hour, keyed by employee id
 */
export const putSettingsHourlyRates = async (
  putSettingsHourlyRatesBody: PutSettingsHourlyRatesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsHourlyRates200> => {
  return customFetch<PutSettingsHourlyRates200>(getPutSettingsHourlyRatesUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsHourlyRatesBody),
  })
}

export const getPutSettingsHourlyRatesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsHourlyRates>>,
    TError,
    { data: PutSettingsHourlyRatesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsHourlyRates>>,
  TError,
  { data: PutSettingsHourlyRatesBody },
  TContext
> => {
  const mutationKey = ['putSettingsHourlyRates']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsHourlyRates>>,
    { data: PutSettingsHourlyRatesBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsHourlyRates(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsHourlyRatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsHourlyRates>>
>
export type PutSettingsHourlyRatesMutationBody = PutSettingsHourlyRatesBody
export type PutSettingsHourlyRatesMutationError = unknown

/**
 * @summary Change what each employee is paid per hour, keyed by employee id
 */
export const usePutSettingsHourlyRates = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsHourlyRates>>,
      TError,
      { data: PutSettingsHourlyRatesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsHourlyRates>>,
  TError,
  { data: PutSettingsHourlyRatesBody },
  TContext
> => {
  return useMutation(getPutSettingsHourlyRatesMutationOptions(options), queryClient)
}
export const getGetSettingsGeneralUrl = () => {
  return `/api/v1/settings/general`
}

/**
 * @summary Whether the restaurant is open for business
 */
export const getSettingsGeneral = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PublicGeneralSettings> => {
  return customFetch<PublicGeneralSettings>(getGetSettingsGeneralUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsGeneralQueryKey = () => {
  return [`/api/v1/settings/general`] as const
}

export const getGetSettingsGeneralQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsGeneral>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsGeneralQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsGeneral>>> = ({ signal }) =>
    getSettingsGeneral({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsGeneral>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsGeneralQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsGeneral>>
>
export type GetSettingsGeneralQueryError = unknown

export function useGetSettingsGeneral<
  TData = Awaited<ReturnType<typeof getSettingsGeneral>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsGeneral>>,
          TError,
          Awaited<ReturnType<typeof getSettingsGeneral>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsGeneral<
  TData = Awaited<ReturnType<typeof getSettingsGeneral>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsGeneral>>,
          TError,
          Awaited<ReturnType<typeof getSettingsGeneral>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsGeneral<
  TData = Awaited<ReturnType<typeof getSettingsGeneral>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether the restaurant is open for business
 */

export function useGetSettingsGeneral<
  TData = Awaited<ReturnType<typeof getSettingsGeneral>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsGeneralQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsGeneralUrl = () => {
  return `/api/v1/settings/general`
}

/**
 * @summary Change the general settings
 */
export const putSettingsGeneral = async (
  putSettingsGeneralBody: PutSettingsGeneralBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PublicGeneralSettings> => {
  return customFetch<PublicGeneralSettings>(getPutSettingsGeneralUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsGeneralBody),
  })
}

export const getPutSettingsGeneralMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsGeneral>>,
    TError,
    { data: PutSettingsGeneralBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsGeneral>>,
  TError,
  { data: PutSettingsGeneralBody },
  TContext
> => {
  const mutationKey = ['putSettingsGeneral']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsGeneral>>,
    { data: PutSettingsGeneralBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsGeneral(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsGeneralMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsGeneral>>
>
export type PutSettingsGeneralMutationBody = PutSettingsGeneralBody
export type PutSettingsGeneralMutationError = unknown

/**
 * @summary Change the general settings
 */
export const usePutSettingsGeneral = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsGeneral>>,
      TError,
      { data: PutSettingsGeneralBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsGeneral>>,
  TError,
  { data: PutSettingsGeneralBody },
  TContext
> => {
  return useMutation(getPutSettingsGeneralMutationOptions(options), queryClient)
}
export const getGetSettingsFranchiseUrl = () => {
  return `/api/v1/settings/franchise`
}

/**
 * @summary This franchise's own terms
 */
export const getSettingsFranchise = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsFranchise200> => {
  return customFetch<GetSettingsFranchise200>(getGetSettingsFranchiseUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsFranchiseQueryKey = () => {
  return [`/api/v1/settings/franchise`] as const
}

export const getGetSettingsFranchiseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsFranchise>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFranchise>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsFranchiseQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsFranchise>>> = ({ signal }) =>
    getSettingsFranchise({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsFranchise>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsFranchiseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsFranchise>>
>
export type GetSettingsFranchiseQueryError = unknown

export function useGetSettingsFranchise<
  TData = Awaited<ReturnType<typeof getSettingsFranchise>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsFranchise>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsFranchise>>,
          TError,
          Awaited<ReturnType<typeof getSettingsFranchise>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsFranchise<
  TData = Awaited<ReturnType<typeof getSettingsFranchise>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsFranchise>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsFranchise>>,
          TError,
          Awaited<ReturnType<typeof getSettingsFranchise>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsFranchise<
  TData = Awaited<ReturnType<typeof getSettingsFranchise>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsFranchise>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary This franchise's own terms
 */

export function useGetSettingsFranchise<
  TData = Awaited<ReturnType<typeof getSettingsFranchise>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsFranchise>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsFranchiseQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsFranchiseUrl = () => {
  return `/api/v1/settings/franchise`
}

/**
 * @summary Change this franchise's terms
 */
export const putSettingsFranchise = async (
  putSettingsFranchiseBody: PutSettingsFranchiseBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsFranchise200> => {
  return customFetch<PutSettingsFranchise200>(getPutSettingsFranchiseUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsFranchiseBody),
  })
}

export const getPutSettingsFranchiseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsFranchise>>,
    TError,
    { data: PutSettingsFranchiseBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsFranchise>>,
  TError,
  { data: PutSettingsFranchiseBody },
  TContext
> => {
  const mutationKey = ['putSettingsFranchise']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsFranchise>>,
    { data: PutSettingsFranchiseBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsFranchise(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsFranchiseMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsFranchise>>
>
export type PutSettingsFranchiseMutationBody = PutSettingsFranchiseBody
export type PutSettingsFranchiseMutationError = unknown

/**
 * @summary Change this franchise's terms
 */
export const usePutSettingsFranchise = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsFranchise>>,
      TError,
      { data: PutSettingsFranchiseBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsFranchise>>,
  TError,
  { data: PutSettingsFranchiseBody },
  TContext
> => {
  return useMutation(getPutSettingsFranchiseMutationOptions(options), queryClient)
}
export const getGetSettingsDesignUrl = () => {
  return `/api/v1/settings/design`
}

/**
 * @summary The look of the customer site
 */
export const getSettingsDesign = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsDesign200> => {
  return customFetch<GetSettingsDesign200>(getGetSettingsDesignUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsDesignQueryKey = () => {
  return [`/api/v1/settings/design`] as const
}

export const getGetSettingsDesignQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsDesign>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsDesign>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsDesignQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsDesign>>> = ({ signal }) =>
    getSettingsDesign({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsDesign>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsDesignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsDesign>>
>
export type GetSettingsDesignQueryError = unknown

export function useGetSettingsDesign<
  TData = Awaited<ReturnType<typeof getSettingsDesign>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsDesign>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsDesign>>,
          TError,
          Awaited<ReturnType<typeof getSettingsDesign>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsDesign<
  TData = Awaited<ReturnType<typeof getSettingsDesign>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsDesign>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsDesign>>,
          TError,
          Awaited<ReturnType<typeof getSettingsDesign>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsDesign<
  TData = Awaited<ReturnType<typeof getSettingsDesign>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsDesign>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The look of the customer site
 */

export function useGetSettingsDesign<
  TData = Awaited<ReturnType<typeof getSettingsDesign>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsDesign>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsDesignQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsDesignUrl = () => {
  return `/api/v1/settings/design`
}

/**
 * @summary Change the look of the customer site
 */
export const putSettingsDesign = async (
  putSettingsDesignBody: PutSettingsDesignBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsDesign200> => {
  return customFetch<PutSettingsDesign200>(getPutSettingsDesignUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsDesignBody),
  })
}

export const getPutSettingsDesignMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsDesign>>,
    TError,
    { data: PutSettingsDesignBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsDesign>>,
  TError,
  { data: PutSettingsDesignBody },
  TContext
> => {
  const mutationKey = ['putSettingsDesign']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsDesign>>,
    { data: PutSettingsDesignBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsDesign(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsDesignMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsDesign>>
>
export type PutSettingsDesignMutationBody = PutSettingsDesignBody
export type PutSettingsDesignMutationError = unknown

/**
 * @summary Change the look of the customer site
 */
export const usePutSettingsDesign = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsDesign>>,
      TError,
      { data: PutSettingsDesignBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsDesign>>,
  TError,
  { data: PutSettingsDesignBody },
  TContext
> => {
  return useMutation(getPutSettingsDesignMutationOptions(options), queryClient)
}
export const getGetSettingsDeliveryUrl = () => {
  return `/api/v1/settings/delivery`
}

/**
 * @summary Where the drivers set out from
 */
export const getSettingsDelivery = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DeliverySettings> => {
  return customFetch<DeliverySettings>(getGetSettingsDeliveryUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsDeliveryQueryKey = () => {
  return [`/api/v1/settings/delivery`] as const
}

export const getGetSettingsDeliveryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsDelivery>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsDelivery>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsDeliveryQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsDelivery>>> = ({ signal }) =>
    getSettingsDelivery({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsDelivery>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsDeliveryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsDelivery>>
>
export type GetSettingsDeliveryQueryError = unknown

export function useGetSettingsDelivery<
  TData = Awaited<ReturnType<typeof getSettingsDelivery>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsDelivery>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsDelivery>>,
          TError,
          Awaited<ReturnType<typeof getSettingsDelivery>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsDelivery<
  TData = Awaited<ReturnType<typeof getSettingsDelivery>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsDelivery>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsDelivery>>,
          TError,
          Awaited<ReturnType<typeof getSettingsDelivery>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsDelivery<
  TData = Awaited<ReturnType<typeof getSettingsDelivery>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsDelivery>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where the drivers set out from
 */

export function useGetSettingsDelivery<
  TData = Awaited<ReturnType<typeof getSettingsDelivery>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsDelivery>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsDeliveryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsDeliveryUrl = () => {
  return `/api/v1/settings/delivery`
}

/**
 * @summary Change where the drivers set out from
 */
export const putSettingsDelivery = async (
  deliverySettingsRequest: DeliverySettingsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeliverySettings> => {
  return customFetch<DeliverySettings>(getPutSettingsDeliveryUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deliverySettingsRequest),
  })
}

export const getPutSettingsDeliveryMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsDelivery>>,
    TError,
    { data: DeliverySettingsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsDelivery>>,
  TError,
  { data: DeliverySettingsRequest },
  TContext
> => {
  const mutationKey = ['putSettingsDelivery']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsDelivery>>,
    { data: DeliverySettingsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsDelivery(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsDeliveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsDelivery>>
>
export type PutSettingsDeliveryMutationBody = DeliverySettingsRequest
export type PutSettingsDeliveryMutationError = unknown

/**
 * @summary Change where the drivers set out from
 */
export const usePutSettingsDelivery = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsDelivery>>,
      TError,
      { data: DeliverySettingsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsDelivery>>,
  TError,
  { data: DeliverySettingsRequest },
  TContext
> => {
  return useMutation(getPutSettingsDeliveryMutationOptions(options), queryClient)
}
export const getGetSettingsBillingUrl = () => {
  return `/api/v1/settings/billing`
}

/**
 * @summary Who to invoice, and how
 */
export const getSettingsBilling = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsBilling200> => {
  return customFetch<GetSettingsBilling200>(getGetSettingsBillingUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsBillingQueryKey = () => {
  return [`/api/v1/settings/billing`] as const
}

export const getGetSettingsBillingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsBilling>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBilling>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsBillingQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsBilling>>> = ({ signal }) =>
    getSettingsBilling({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsBilling>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsBillingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsBilling>>
>
export type GetSettingsBillingQueryError = unknown

export function useGetSettingsBilling<
  TData = Awaited<ReturnType<typeof getSettingsBilling>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBilling>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsBilling>>,
          TError,
          Awaited<ReturnType<typeof getSettingsBilling>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsBilling<
  TData = Awaited<ReturnType<typeof getSettingsBilling>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsBilling>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsBilling>>,
          TError,
          Awaited<ReturnType<typeof getSettingsBilling>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsBilling<
  TData = Awaited<ReturnType<typeof getSettingsBilling>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBilling>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Who to invoice, and how
 */

export function useGetSettingsBilling<
  TData = Awaited<ReturnType<typeof getSettingsBilling>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBilling>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsBillingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsBillingUrl = () => {
  return `/api/v1/settings/billing`
}

/**
 * @summary Change the billing details
 */
export const putSettingsBilling = async (
  putSettingsBillingBody: PutSettingsBillingBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsBilling200> => {
  return customFetch<PutSettingsBilling200>(getPutSettingsBillingUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsBillingBody),
  })
}

export const getPutSettingsBillingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsBilling>>,
    TError,
    { data: PutSettingsBillingBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsBilling>>,
  TError,
  { data: PutSettingsBillingBody },
  TContext
> => {
  const mutationKey = ['putSettingsBilling']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsBilling>>,
    { data: PutSettingsBillingBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsBilling(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsBillingMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsBilling>>
>
export type PutSettingsBillingMutationBody = PutSettingsBillingBody
export type PutSettingsBillingMutationError = unknown

/**
 * @summary Change the billing details
 */
export const usePutSettingsBilling = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsBilling>>,
      TError,
      { data: PutSettingsBillingBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsBilling>>,
  TError,
  { data: PutSettingsBillingBody },
  TContext
> => {
  return useMutation(getPutSettingsBillingMutationOptions(options), queryClient)
}
export const getGetSettingsBasicUrl = () => {
  return `/api/v1/settings/basic`
}

/**
 * @summary The basic settings, without the API credential
 */
export const getSettingsBasic = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsBasic200> => {
  return customFetch<GetSettingsBasic200>(getGetSettingsBasicUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsBasicQueryKey = () => {
  return [`/api/v1/settings/basic`] as const
}

export const getGetSettingsBasicQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsBasic>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasic>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsBasicQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsBasic>>> = ({ signal }) =>
    getSettingsBasic({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsBasic>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsBasicQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsBasic>>>
export type GetSettingsBasicQueryError = unknown

export function useGetSettingsBasic<
  TData = Awaited<ReturnType<typeof getSettingsBasic>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasic>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsBasic>>,
          TError,
          Awaited<ReturnType<typeof getSettingsBasic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsBasic<
  TData = Awaited<ReturnType<typeof getSettingsBasic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasic>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsBasic>>,
          TError,
          Awaited<ReturnType<typeof getSettingsBasic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsBasic<
  TData = Awaited<ReturnType<typeof getSettingsBasic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasic>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The basic settings, without the API credential
 */

export function useGetSettingsBasic<
  TData = Awaited<ReturnType<typeof getSettingsBasic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasic>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsBasicQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsBasicUrl = () => {
  return `/api/v1/settings/basic`
}

/**
 * @summary Change the basic settings
 */
export const putSettingsBasic = async (
  putSettingsBasicBody: PutSettingsBasicBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PutSettingsBasic200> => {
  return customFetch<PutSettingsBasic200>(getPutSettingsBasicUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsBasicBody),
  })
}

export const getPutSettingsBasicMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsBasic>>,
    TError,
    { data: PutSettingsBasicBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsBasic>>,
  TError,
  { data: PutSettingsBasicBody },
  TContext
> => {
  const mutationKey = ['putSettingsBasic']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsBasic>>,
    { data: PutSettingsBasicBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsBasic(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsBasicMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsBasic>>
>
export type PutSettingsBasicMutationBody = PutSettingsBasicBody
export type PutSettingsBasicMutationError = unknown

/**
 * @summary Change the basic settings
 */
export const usePutSettingsBasic = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsBasic>>,
      TError,
      { data: PutSettingsBasicBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsBasic>>,
  TError,
  { data: PutSettingsBasicBody },
  TContext
> => {
  return useMutation(getPutSettingsBasicMutationOptions(options), queryClient)
}
export const getGetSuperAdminPartnersUrl = () => {
  return `/api/v1/super-admin/partners`
}

/**
 * @summary Every partner
 */
export const getSuperAdminPartners = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminPartners200> => {
  return customFetch<GetSuperAdminPartners200>(getGetSuperAdminPartnersUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminPartnersQueryKey = () => {
  return [`/api/v1/super-admin/partners`] as const
}

export const getGetSuperAdminPartnersQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminPartners>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPartners>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminPartnersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminPartners>>> = ({ signal }) =>
    getSuperAdminPartners({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminPartnersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminPartners>>
>
export type GetSuperAdminPartnersQueryError = unknown

export function useGetSuperAdminPartners<
  TData = Awaited<ReturnType<typeof getSuperAdminPartners>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPartners>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminPartners>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminPartners>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminPartners<
  TData = Awaited<ReturnType<typeof getSuperAdminPartners>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPartners>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminPartners>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminPartners>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminPartners<
  TData = Awaited<ReturnType<typeof getSuperAdminPartners>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPartners>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every partner
 */

export function useGetSuperAdminPartners<
  TData = Awaited<ReturnType<typeof getSuperAdminPartners>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPartners>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminPartnersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuperAdminPartnersUrl = () => {
  return `/api/v1/super-admin/partners`
}

/**
 * @summary Add a partner
 */
export const postSuperAdminPartners = async (
  postSuperAdminPartnersBody?: PostSuperAdminPartnersBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminPartners200> => {
  return customFetch<PostSuperAdminPartners200>(getPostSuperAdminPartnersUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuperAdminPartnersBody),
  })
}

export const getPostSuperAdminPartnersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminPartners>>,
    TError,
    { data?: PostSuperAdminPartnersBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminPartners>>,
  TError,
  { data?: PostSuperAdminPartnersBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminPartners']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminPartners>>,
    { data?: PostSuperAdminPartnersBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSuperAdminPartners(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminPartnersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminPartners>>
>
export type PostSuperAdminPartnersMutationBody = PostSuperAdminPartnersBody | undefined
export type PostSuperAdminPartnersMutationError = unknown

/**
 * @summary Add a partner
 */
export const usePostSuperAdminPartners = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminPartners>>,
      TError,
      { data?: PostSuperAdminPartnersBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminPartners>>,
  TError,
  { data?: PostSuperAdminPartnersBody },
  TContext
> => {
  return useMutation(getPostSuperAdminPartnersMutationOptions(options), queryClient)
}
export const getGetSuperAdminPackagesUrl = () => {
  return `/api/v1/super-admin/packages`
}

/**
 * @summary Every tier, with the features it carries
 */
export const getSuperAdminPackages = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminPackages200> => {
  return customFetch<GetSuperAdminPackages200>(getGetSuperAdminPackagesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminPackagesQueryKey = () => {
  return [`/api/v1/super-admin/packages`] as const
}

export const getGetSuperAdminPackagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminPackages>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPackages>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminPackagesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminPackages>>> = ({ signal }) =>
    getSuperAdminPackages({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminPackages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminPackagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminPackages>>
>
export type GetSuperAdminPackagesQueryError = unknown

export function useGetSuperAdminPackages<
  TData = Awaited<ReturnType<typeof getSuperAdminPackages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPackages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminPackages>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminPackages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminPackages<
  TData = Awaited<ReturnType<typeof getSuperAdminPackages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPackages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminPackages>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminPackages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminPackages<
  TData = Awaited<ReturnType<typeof getSuperAdminPackages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPackages>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every tier, with the features it carries
 */

export function useGetSuperAdminPackages<
  TData = Awaited<ReturnType<typeof getSuperAdminPackages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminPackages>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminPackagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuperAdminPackagesUrl = () => {
  return `/api/v1/super-admin/packages`
}

/**
 * @summary Add a tier
 */
export const postSuperAdminPackages = async (
  postSuperAdminPackagesBody: PostSuperAdminPackagesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminPackages200> => {
  return customFetch<PostSuperAdminPackages200>(getPostSuperAdminPackagesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuperAdminPackagesBody),
  })
}

export const getPostSuperAdminPackagesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminPackages>>,
    TError,
    { data: PostSuperAdminPackagesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminPackages>>,
  TError,
  { data: PostSuperAdminPackagesBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminPackages']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminPackages>>,
    { data: PostSuperAdminPackagesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSuperAdminPackages(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminPackagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminPackages>>
>
export type PostSuperAdminPackagesMutationBody = PostSuperAdminPackagesBody
export type PostSuperAdminPackagesMutationError = unknown

/**
 * @summary Add a tier
 */
export const usePostSuperAdminPackages = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminPackages>>,
      TError,
      { data: PostSuperAdminPackagesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminPackages>>,
  TError,
  { data: PostSuperAdminPackagesBody },
  TContext
> => {
  return useMutation(getPostSuperAdminPackagesMutationOptions(options), queryClient)
}
export const getPostSuperAdminPackagesReorderUrl = () => {
  return `/api/v1/super-admin/packages/reorder`
}

/**
 * @summary Put the tiers in a new order
 */
export const postSuperAdminPackagesReorder = async (
  packageReorderRequest: PackageReorderRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminPackagesReorder200> => {
  return customFetch<PostSuperAdminPackagesReorder200>(getPostSuperAdminPackagesReorderUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packageReorderRequest),
  })
}

export const getPostSuperAdminPackagesReorderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminPackagesReorder>>,
    TError,
    { data: PackageReorderRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminPackagesReorder>>,
  TError,
  { data: PackageReorderRequest },
  TContext
> => {
  const mutationKey = ['postSuperAdminPackagesReorder']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminPackagesReorder>>,
    { data: PackageReorderRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postSuperAdminPackagesReorder(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminPackagesReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminPackagesReorder>>
>
export type PostSuperAdminPackagesReorderMutationBody = PackageReorderRequest
export type PostSuperAdminPackagesReorderMutationError = unknown

/**
 * @summary Put the tiers in a new order
 */
export const usePostSuperAdminPackagesReorder = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminPackagesReorder>>,
      TError,
      { data: PackageReorderRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminPackagesReorder>>,
  TError,
  { data: PackageReorderRequest },
  TContext
> => {
  return useMutation(getPostSuperAdminPackagesReorderMutationOptions(options), queryClient)
}
export const getPostSuperAdminMarketingPagesSlugPublishUrl = (slug: string) => {
  return `/api/v1/super-admin/marketing-pages/${slug}/publish`
}

/**
 * @summary Publish this page's draft
 */
export const postSuperAdminMarketingPagesSlugPublish = async (
  slug: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminMarketingPagesSlugPublish200> => {
  return customFetch<PostSuperAdminMarketingPagesSlugPublish200>(
    getPostSuperAdminMarketingPagesSlugPublishUrl(slug),
    {
      ...options,
      method: 'POST',
    },
  )
}

export const getPostSuperAdminMarketingPagesSlugPublishMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugPublish>>,
    TError,
    { slug: string },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugPublish>>,
  TError,
  { slug: string },
  TContext
> => {
  const mutationKey = ['postSuperAdminMarketingPagesSlugPublish']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugPublish>>,
    { slug: string }
  > = (props) => {
    const { slug } = props ?? {}

    return postSuperAdminMarketingPagesSlugPublish(slug, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminMarketingPagesSlugPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugPublish>>
>

export type PostSuperAdminMarketingPagesSlugPublishMutationError = unknown

/**
 * @summary Publish this page's draft
 */
export const usePostSuperAdminMarketingPagesSlugPublish = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugPublish>>,
      TError,
      { slug: string },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugPublish>>,
  TError,
  { slug: string },
  TContext
> => {
  return useMutation(
    getPostSuperAdminMarketingPagesSlugPublishMutationOptions(options),
    queryClient,
  )
}
export const getPostSuperAdminMarketingPagesSlugDomainUrl = (slug: string) => {
  return `/api/v1/super-admin/marketing-pages/${slug}/domain`
}

/**
 * @summary Point a customer's own domain at this page
 */
export const postSuperAdminMarketingPagesSlugDomain = async (
  slug: string,
  postSuperAdminMarketingPagesSlugDomainBody?: PostSuperAdminMarketingPagesSlugDomainBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminMarketingPagesSlugDomain200> => {
  return customFetch<PostSuperAdminMarketingPagesSlugDomain200>(
    getPostSuperAdminMarketingPagesSlugDomainUrl(slug),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(postSuperAdminMarketingPagesSlugDomainBody),
    },
  )
}

export const getPostSuperAdminMarketingPagesSlugDomainMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugDomain>>,
    TError,
    { slug: string; data?: PostSuperAdminMarketingPagesSlugDomainBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugDomain>>,
  TError,
  { slug: string; data?: PostSuperAdminMarketingPagesSlugDomainBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminMarketingPagesSlugDomain']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugDomain>>,
    { slug: string; data?: PostSuperAdminMarketingPagesSlugDomainBody }
  > = (props) => {
    const { slug, data } = props ?? {}

    return postSuperAdminMarketingPagesSlugDomain(slug, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminMarketingPagesSlugDomainMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugDomain>>
>
export type PostSuperAdminMarketingPagesSlugDomainMutationBody =
  PostSuperAdminMarketingPagesSlugDomainBody | undefined
export type PostSuperAdminMarketingPagesSlugDomainMutationError = unknown

/**
 * @summary Point a customer's own domain at this page
 */
export const usePostSuperAdminMarketingPagesSlugDomain = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugDomain>>,
      TError,
      { slug: string; data?: PostSuperAdminMarketingPagesSlugDomainBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminMarketingPagesSlugDomain>>,
  TError,
  { slug: string; data?: PostSuperAdminMarketingPagesSlugDomainBody },
  TContext
> => {
  return useMutation(getPostSuperAdminMarketingPagesSlugDomainMutationOptions(options), queryClient)
}
export const getGetSuperAdminInvoicesUrl = () => {
  return `/api/v1/super-admin/invoices`
}

/**
 * @summary Every invoice the platform has raised
 */
export const getSuperAdminInvoices = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminInvoices200> => {
  return customFetch<GetSuperAdminInvoices200>(getGetSuperAdminInvoicesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminInvoicesQueryKey = () => {
  return [`/api/v1/super-admin/invoices`] as const
}

export const getGetSuperAdminInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminInvoices>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoices>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminInvoicesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminInvoices>>> = ({ signal }) =>
    getSuperAdminInvoices({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminInvoices>>
>
export type GetSuperAdminInvoicesQueryError = unknown

export function useGetSuperAdminInvoices<
  TData = Awaited<ReturnType<typeof getSuperAdminInvoices>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminInvoices>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminInvoices<
  TData = Awaited<ReturnType<typeof getSuperAdminInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminInvoices>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminInvoices<
  TData = Awaited<ReturnType<typeof getSuperAdminInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoices>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every invoice the platform has raised
 */

export function useGetSuperAdminInvoices<
  TData = Awaited<ReturnType<typeof getSuperAdminInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoices>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuperAdminInvoicesUrl = () => {
  return `/api/v1/super-admin/invoices`
}

/**
 * @summary Raise an invoice by hand
 */
export const postSuperAdminInvoices = async (
  postSuperAdminInvoicesBody?: PostSuperAdminInvoicesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminInvoices200> => {
  return customFetch<PostSuperAdminInvoices200>(getPostSuperAdminInvoicesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuperAdminInvoicesBody),
  })
}

export const getPostSuperAdminInvoicesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminInvoices>>,
    TError,
    { data?: PostSuperAdminInvoicesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminInvoices>>,
  TError,
  { data?: PostSuperAdminInvoicesBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminInvoices']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminInvoices>>,
    { data?: PostSuperAdminInvoicesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSuperAdminInvoices(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminInvoicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminInvoices>>
>
export type PostSuperAdminInvoicesMutationBody = PostSuperAdminInvoicesBody | undefined
export type PostSuperAdminInvoicesMutationError = unknown

/**
 * @summary Raise an invoice by hand
 */
export const usePostSuperAdminInvoices = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminInvoices>>,
      TError,
      { data?: PostSuperAdminInvoicesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminInvoices>>,
  TError,
  { data?: PostSuperAdminInvoicesBody },
  TContext
> => {
  return useMutation(getPostSuperAdminInvoicesMutationOptions(options), queryClient)
}
export const getPostSuperAdminInvoicesIdResendUrl = (id: number) => {
  return `/api/v1/super-admin/invoices/${id}/resend`
}

/**
 * @summary Send an invoice again
 */
export const postSuperAdminInvoicesIdResend = async (
  id: number,
  postSuperAdminInvoicesIdResendBody?: PostSuperAdminInvoicesIdResendBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminInvoicesIdResend200> => {
  return customFetch<PostSuperAdminInvoicesIdResend200>(getPostSuperAdminInvoicesIdResendUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuperAdminInvoicesIdResendBody),
  })
}

export const getPostSuperAdminInvoicesIdResendMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminInvoicesIdResend>>,
    TError,
    { id: number; data?: PostSuperAdminInvoicesIdResendBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminInvoicesIdResend>>,
  TError,
  { id: number; data?: PostSuperAdminInvoicesIdResendBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminInvoicesIdResend']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminInvoicesIdResend>>,
    { id: number; data?: PostSuperAdminInvoicesIdResendBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return postSuperAdminInvoicesIdResend(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminInvoicesIdResendMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminInvoicesIdResend>>
>
export type PostSuperAdminInvoicesIdResendMutationBody =
  PostSuperAdminInvoicesIdResendBody | undefined
export type PostSuperAdminInvoicesIdResendMutationError = unknown

/**
 * @summary Send an invoice again
 */
export const usePostSuperAdminInvoicesIdResend = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminInvoicesIdResend>>,
      TError,
      { id: number; data?: PostSuperAdminInvoicesIdResendBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminInvoicesIdResend>>,
  TError,
  { id: number; data?: PostSuperAdminInvoicesIdResendBody },
  TContext
> => {
  return useMutation(getPostSuperAdminInvoicesIdResendMutationOptions(options), queryClient)
}
export const getGetSuperAdminFranchisesUrl = () => {
  return `/api/v1/super-admin/franchises`
}

/**
 * @summary Every franchise, with its domains and tier
 */
export const getSuperAdminFranchises = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchises200> => {
  return customFetch<GetSuperAdminFranchises200>(getGetSuperAdminFranchisesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminFranchisesQueryKey = () => {
  return [`/api/v1/super-admin/franchises`] as const
}

export const getGetSuperAdminFranchisesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchises>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminFranchises>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminFranchisesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminFranchises>>> = ({
    signal,
  }) => getSuperAdminFranchises({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchises>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchises>>
>
export type GetSuperAdminFranchisesQueryError = unknown

export function useGetSuperAdminFranchises<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchises>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminFranchises>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchises>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchises<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminFranchises>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchises>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchises<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminFranchises>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every franchise, with its domains and tier
 */

export function useGetSuperAdminFranchises<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminFranchises>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuperAdminFranchisesUrl = () => {
  return `/api/v1/super-admin/franchises`
}

/**
 * @summary Register a franchise
 */
export const postSuperAdminFranchises = async (
  postSuperAdminFranchisesBody: PostSuperAdminFranchisesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchises200> => {
  return customFetch<PostSuperAdminFranchises200>(getPostSuperAdminFranchisesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuperAdminFranchisesBody),
  })
}

export const getPostSuperAdminFranchisesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchises>>,
    TError,
    { data: PostSuperAdminFranchisesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchises>>,
  TError,
  { data: PostSuperAdminFranchisesBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchises']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchises>>,
    { data: PostSuperAdminFranchisesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSuperAdminFranchises(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminFranchises>>
>
export type PostSuperAdminFranchisesMutationBody = PostSuperAdminFranchisesBody
export type PostSuperAdminFranchisesMutationError = unknown

/**
 * @summary Register a franchise
 */
export const usePostSuperAdminFranchises = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchises>>,
      TError,
      { data: PostSuperAdminFranchisesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchises>>,
  TError,
  { data: PostSuperAdminFranchisesBody },
  TContext
> => {
  return useMutation(getPostSuperAdminFranchisesMutationOptions(options), queryClient)
}
export const getPostSuperAdminFranchisesFranchiseIdWireguardProvisionUrl = (
  franchiseId: number,
) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/wireguard/provision`
}

/**
 * @summary Provision this franchise's WireGuard peer
 */
export const postSuperAdminFranchisesFranchiseIdWireguardProvision = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchisesFranchiseIdWireguardProvision200> => {
  return customFetch<PostSuperAdminFranchisesFranchiseIdWireguardProvision200>(
    getPostSuperAdminFranchisesFranchiseIdWireguardProvisionUrl(franchiseId),
    {
      ...options,
      method: 'POST',
    },
  )
}

export const getPostSuperAdminFranchisesFranchiseIdWireguardProvisionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdWireguardProvision>>,
    TError,
    { franchiseId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdWireguardProvision>>,
  TError,
  { franchiseId: number },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchisesFranchiseIdWireguardProvision']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdWireguardProvision>>,
    { franchiseId: number }
  > = (props) => {
    const { franchiseId } = props ?? {}

    return postSuperAdminFranchisesFranchiseIdWireguardProvision(franchiseId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesFranchiseIdWireguardProvisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdWireguardProvision>>
>

export type PostSuperAdminFranchisesFranchiseIdWireguardProvisionMutationError = unknown

/**
 * @summary Provision this franchise's WireGuard peer
 */
export const usePostSuperAdminFranchisesFranchiseIdWireguardProvision = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdWireguardProvision>>,
      TError,
      { franchiseId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdWireguardProvision>>,
  TError,
  { franchiseId: number },
  TContext
> => {
  return useMutation(
    getPostSuperAdminFranchisesFranchiseIdWireguardProvisionMutationOptions(options),
    queryClient,
  )
}
export const getPostSuperAdminFranchisesFranchiseIdSsoTokenUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/sso-token`
}

/**
 * @summary Sign in to a franchise's manager as its administrator
 */
export const postSuperAdminFranchisesFranchiseIdSsoToken = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchisesFranchiseIdSsoToken200> => {
  return customFetch<PostSuperAdminFranchisesFranchiseIdSsoToken200>(
    getPostSuperAdminFranchisesFranchiseIdSsoTokenUrl(franchiseId),
    {
      ...options,
      method: 'POST',
    },
  )
}

export const getPostSuperAdminFranchisesFranchiseIdSsoTokenMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdSsoToken>>,
    TError,
    { franchiseId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdSsoToken>>,
  TError,
  { franchiseId: number },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchisesFranchiseIdSsoToken']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdSsoToken>>,
    { franchiseId: number }
  > = (props) => {
    const { franchiseId } = props ?? {}

    return postSuperAdminFranchisesFranchiseIdSsoToken(franchiseId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesFranchiseIdSsoTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdSsoToken>>
>

export type PostSuperAdminFranchisesFranchiseIdSsoTokenMutationError = unknown

/**
 * @summary Sign in to a franchise's manager as its administrator
 */
export const usePostSuperAdminFranchisesFranchiseIdSsoToken = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdSsoToken>>,
      TError,
      { franchiseId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdSsoToken>>,
  TError,
  { franchiseId: number },
  TContext
> => {
  return useMutation(
    getPostSuperAdminFranchisesFranchiseIdSsoTokenMutationOptions(options),
    queryClient,
  )
}
export const getPostSuperAdminFranchisesFranchiseIdRestoreDatabaseUrl = (
  franchiseId: number,
  params?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/super-admin/franchises/${franchiseId}/restore-database?${stringifiedParams}`
    : `/api/v1/super-admin/franchises/${franchiseId}/restore-database`
}

/**
 * @summary Restore a franchise database from a dump - destroys everything it has
 */
export const postSuperAdminFranchisesFranchiseIdRestoreDatabase = async (
  franchiseId: number,
  postSuperAdminFranchisesFranchiseIdRestoreDatabaseBody?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseBody,
  params?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchisesFranchiseIdRestoreDatabase200> => {
  return customFetch<PostSuperAdminFranchisesFranchiseIdRestoreDatabase200>(
    getPostSuperAdminFranchisesFranchiseIdRestoreDatabaseUrl(franchiseId, params),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(postSuperAdminFranchisesFranchiseIdRestoreDatabaseBody),
    },
  )
}

export const getPostSuperAdminFranchisesFranchiseIdRestoreDatabaseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdRestoreDatabase>>,
    TError,
    {
      franchiseId: number
      data?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseBody
      params?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseParams
    },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdRestoreDatabase>>,
  TError,
  {
    franchiseId: number
    data?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseBody
    params?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseParams
  },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchisesFranchiseIdRestoreDatabase']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdRestoreDatabase>>,
    {
      franchiseId: number
      data?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseBody
      params?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseParams
    }
  > = (props) => {
    const { franchiseId, data, params } = props ?? {}

    return postSuperAdminFranchisesFranchiseIdRestoreDatabase(
      franchiseId,
      data,
      params,
      requestOptions,
    )
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesFranchiseIdRestoreDatabaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdRestoreDatabase>>
>
export type PostSuperAdminFranchisesFranchiseIdRestoreDatabaseMutationBody =
  PostSuperAdminFranchisesFranchiseIdRestoreDatabaseBody | undefined
export type PostSuperAdminFranchisesFranchiseIdRestoreDatabaseMutationError = unknown

/**
 * @summary Restore a franchise database from a dump - destroys everything it has
 */
export const usePostSuperAdminFranchisesFranchiseIdRestoreDatabase = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdRestoreDatabase>>,
      TError,
      {
        franchiseId: number
        data?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseBody
        params?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseParams
      },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdRestoreDatabase>>,
  TError,
  {
    franchiseId: number
    data?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseBody
    params?: PostSuperAdminFranchisesFranchiseIdRestoreDatabaseParams
  },
  TContext
> => {
  return useMutation(
    getPostSuperAdminFranchisesFranchiseIdRestoreDatabaseMutationOptions(options),
    queryClient,
  )
}
export const getGetSuperAdminFranchisesFranchiseIdPartnersUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/partners`
}

/**
 * @summary The partners holding a share in this franchise
 */
export const getSuperAdminFranchisesFranchiseIdPartners = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdPartners200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdPartners200>(
    getGetSuperAdminFranchisesFranchiseIdPartnersUrl(franchiseId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdPartnersQueryKey = (franchiseId: number) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/partners`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdPartnersQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSuperAdminFranchisesFranchiseIdPartnersQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdPartners(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdPartnersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>
>
export type GetSuperAdminFranchisesFranchiseIdPartnersQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdPartners<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdPartners<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdPartners<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The partners holding a share in this franchise
 */

export function useGetSuperAdminFranchisesFranchiseIdPartners<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdPartners>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdPartnersQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuperAdminFranchisesFranchiseIdPartnersUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/partners`
}

/**
 * @summary Give a partner a share in this franchise
 */
export const postSuperAdminFranchisesFranchiseIdPartners = async (
  franchiseId: number,
  postSuperAdminFranchisesFranchiseIdPartnersBody?: PostSuperAdminFranchisesFranchiseIdPartnersBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchisesFranchiseIdPartners200> => {
  return customFetch<PostSuperAdminFranchisesFranchiseIdPartners200>(
    getPostSuperAdminFranchisesFranchiseIdPartnersUrl(franchiseId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(postSuperAdminFranchisesFranchiseIdPartnersBody),
    },
  )
}

export const getPostSuperAdminFranchisesFranchiseIdPartnersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdPartners>>,
    TError,
    { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdPartnersBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdPartners>>,
  TError,
  { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdPartnersBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchisesFranchiseIdPartners']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdPartners>>,
    { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdPartnersBody }
  > = (props) => {
    const { franchiseId, data } = props ?? {}

    return postSuperAdminFranchisesFranchiseIdPartners(franchiseId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesFranchiseIdPartnersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdPartners>>
>
export type PostSuperAdminFranchisesFranchiseIdPartnersMutationBody =
  PostSuperAdminFranchisesFranchiseIdPartnersBody | undefined
export type PostSuperAdminFranchisesFranchiseIdPartnersMutationError = unknown

/**
 * @summary Give a partner a share in this franchise
 */
export const usePostSuperAdminFranchisesFranchiseIdPartners = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdPartners>>,
      TError,
      { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdPartnersBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdPartners>>,
  TError,
  { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdPartnersBody },
  TContext
> => {
  return useMutation(
    getPostSuperAdminFranchisesFranchiseIdPartnersMutationOptions(options),
    queryClient,
  )
}
export const getGetSuperAdminFranchisesFranchiseIdModuleBillingUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/module-billing`
}

/**
 * @summary Module charges for this franchise
 */
export const getSuperAdminFranchisesFranchiseIdModuleBilling = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdModuleBilling200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdModuleBilling200>(
    getGetSuperAdminFranchisesFranchiseIdModuleBillingUrl(franchiseId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdModuleBillingQueryKey = (franchiseId: number) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/module-billing`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdModuleBillingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetSuperAdminFranchisesFranchiseIdModuleBillingQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdModuleBilling(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdModuleBillingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>
>
export type GetSuperAdminFranchisesFranchiseIdModuleBillingQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdModuleBilling<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdModuleBilling<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdModuleBilling<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Module charges for this franchise
 */

export function useGetSuperAdminFranchisesFranchiseIdModuleBilling<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdModuleBilling>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdModuleBillingQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuperAdminFranchisesFranchiseIdModuleBillingUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/module-billing`
}

/**
 * @summary Price a module for this franchise
 */
export const postSuperAdminFranchisesFranchiseIdModuleBilling = async (
  franchiseId: number,
  postSuperAdminFranchisesFranchiseIdModuleBillingBody?: PostSuperAdminFranchisesFranchiseIdModuleBillingBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchisesFranchiseIdModuleBilling200> => {
  return customFetch<PostSuperAdminFranchisesFranchiseIdModuleBilling200>(
    getPostSuperAdminFranchisesFranchiseIdModuleBillingUrl(franchiseId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(postSuperAdminFranchisesFranchiseIdModuleBillingBody),
    },
  )
}

export const getPostSuperAdminFranchisesFranchiseIdModuleBillingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdModuleBilling>>,
    TError,
    { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdModuleBillingBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdModuleBilling>>,
  TError,
  { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdModuleBillingBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchisesFranchiseIdModuleBilling']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdModuleBilling>>,
    { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdModuleBillingBody }
  > = (props) => {
    const { franchiseId, data } = props ?? {}

    return postSuperAdminFranchisesFranchiseIdModuleBilling(franchiseId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesFranchiseIdModuleBillingMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdModuleBilling>>
>
export type PostSuperAdminFranchisesFranchiseIdModuleBillingMutationBody =
  PostSuperAdminFranchisesFranchiseIdModuleBillingBody | undefined
export type PostSuperAdminFranchisesFranchiseIdModuleBillingMutationError = unknown

/**
 * @summary Price a module for this franchise
 */
export const usePostSuperAdminFranchisesFranchiseIdModuleBilling = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdModuleBilling>>,
      TError,
      { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdModuleBillingBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdModuleBilling>>,
  TError,
  { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdModuleBillingBody },
  TContext
> => {
  return useMutation(
    getPostSuperAdminFranchisesFranchiseIdModuleBillingMutationOptions(options),
    queryClient,
  )
}
export const getPostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdUrl = (
  franchiseId: number,
  sourceId: number,
) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/integrations/copy-from/${sourceId}`
}

/**
 * @summary Copy platform-wide credentials from another franchise
 */
export const postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId = async (
  franchiseId: number,
  sourceId: number,
  postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody?: PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId200> => {
  return customFetch<PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId200>(
    getPostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdUrl(franchiseId, sourceId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody),
    },
  )
}

export const getPostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId>>,
    TError,
    {
      franchiseId: number
      sourceId: number
      data?: PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody
    },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId>>,
  TError,
  {
    franchiseId: number
    sourceId: number
    data?: PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody
  },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId>>,
    {
      franchiseId: number
      sourceId: number
      data?: PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody
    }
  > = (props) => {
    const { franchiseId, sourceId, data } = props ?? {}

    return postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId(
      franchiseId,
      sourceId,
      data,
      requestOptions,
    )
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId>>
  >
export type PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdMutationBody =
  PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody | undefined
export type PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdMutationError = unknown

/**
 * @summary Copy platform-wide credentials from another franchise
 */
export const usePostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId>>,
      TError,
      {
        franchiseId: number
        sourceId: number
        data?: PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody
      },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceId>>,
  TError,
  {
    franchiseId: number
    sourceId: number
    data?: PostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdBody
  },
  TContext
> => {
  return useMutation(
    getPostSuperAdminFranchisesFranchiseIdIntegrationsCopyFromSourceIdMutationOptions(options),
    queryClient,
  )
}
export const getGetSuperAdminFranchisesFranchiseIdHardwareUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/hardware`
}

/**
 * @summary Hardware rented to this franchise
 */
export const getSuperAdminFranchisesFranchiseIdHardware = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdHardware200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdHardware200>(
    getGetSuperAdminFranchisesFranchiseIdHardwareUrl(franchiseId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdHardwareQueryKey = (franchiseId: number) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/hardware`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdHardwareQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSuperAdminFranchisesFranchiseIdHardwareQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdHardware(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdHardwareQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>
>
export type GetSuperAdminFranchisesFranchiseIdHardwareQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdHardware<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdHardware<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdHardware<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Hardware rented to this franchise
 */

export function useGetSuperAdminFranchisesFranchiseIdHardware<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdHardware>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdHardwareQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuperAdminFranchisesFranchiseIdHardwareUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/hardware`
}

/**
 * @summary Rent a device to this franchise
 */
export const postSuperAdminFranchisesFranchiseIdHardware = async (
  franchiseId: number,
  postSuperAdminFranchisesFranchiseIdHardwareBody?: PostSuperAdminFranchisesFranchiseIdHardwareBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchisesFranchiseIdHardware200> => {
  return customFetch<PostSuperAdminFranchisesFranchiseIdHardware200>(
    getPostSuperAdminFranchisesFranchiseIdHardwareUrl(franchiseId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(postSuperAdminFranchisesFranchiseIdHardwareBody),
    },
  )
}

export const getPostSuperAdminFranchisesFranchiseIdHardwareMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdHardware>>,
    TError,
    { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdHardwareBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdHardware>>,
  TError,
  { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdHardwareBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchisesFranchiseIdHardware']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdHardware>>,
    { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdHardwareBody }
  > = (props) => {
    const { franchiseId, data } = props ?? {}

    return postSuperAdminFranchisesFranchiseIdHardware(franchiseId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesFranchiseIdHardwareMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdHardware>>
>
export type PostSuperAdminFranchisesFranchiseIdHardwareMutationBody =
  PostSuperAdminFranchisesFranchiseIdHardwareBody | undefined
export type PostSuperAdminFranchisesFranchiseIdHardwareMutationError = unknown

/**
 * @summary Rent a device to this franchise
 */
export const usePostSuperAdminFranchisesFranchiseIdHardware = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdHardware>>,
      TError,
      { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdHardwareBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdHardware>>,
  TError,
  { franchiseId: number; data?: PostSuperAdminFranchisesFranchiseIdHardwareBody },
  TContext
> => {
  return useMutation(
    getPostSuperAdminFranchisesFranchiseIdHardwareMutationOptions(options),
    queryClient,
  )
}
export const getPostSuperAdminFranchisesFranchiseIdDomainsProvisionUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/domains/provision`
}

/**
 * @summary Create the proxy hosts and certificates for this franchise's domains
 */
export const postSuperAdminFranchisesFranchiseIdDomainsProvision = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminFranchisesFranchiseIdDomainsProvision200> => {
  return customFetch<PostSuperAdminFranchisesFranchiseIdDomainsProvision200>(
    getPostSuperAdminFranchisesFranchiseIdDomainsProvisionUrl(franchiseId),
    {
      ...options,
      method: 'POST',
    },
  )
}

export const getPostSuperAdminFranchisesFranchiseIdDomainsProvisionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdDomainsProvision>>,
    TError,
    { franchiseId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdDomainsProvision>>,
  TError,
  { franchiseId: number },
  TContext
> => {
  const mutationKey = ['postSuperAdminFranchisesFranchiseIdDomainsProvision']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdDomainsProvision>>,
    { franchiseId: number }
  > = (props) => {
    const { franchiseId } = props ?? {}

    return postSuperAdminFranchisesFranchiseIdDomainsProvision(franchiseId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminFranchisesFranchiseIdDomainsProvisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdDomainsProvision>>
>

export type PostSuperAdminFranchisesFranchiseIdDomainsProvisionMutationError = unknown

/**
 * @summary Create the proxy hosts and certificates for this franchise's domains
 */
export const usePostSuperAdminFranchisesFranchiseIdDomainsProvision = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdDomainsProvision>>,
      TError,
      { franchiseId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminFranchisesFranchiseIdDomainsProvision>>,
  TError,
  { franchiseId: number },
  TContext
> => {
  return useMutation(
    getPostSuperAdminFranchisesFranchiseIdDomainsProvisionMutationOptions(options),
    queryClient,
  )
}
export const getPostSuperAdminBillingRunUrl = () => {
  return `/api/v1/super-admin/billing/run`
}

/**
 * @summary Run billing for a month
 */
export const postSuperAdminBillingRun = async (
  postSuperAdminBillingRunBody?: PostSuperAdminBillingRunBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminBillingRun200> => {
  return customFetch<PostSuperAdminBillingRun200>(getPostSuperAdminBillingRunUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuperAdminBillingRunBody),
  })
}

export const getPostSuperAdminBillingRunMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminBillingRun>>,
    TError,
    { data?: PostSuperAdminBillingRunBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminBillingRun>>,
  TError,
  { data?: PostSuperAdminBillingRunBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminBillingRun']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminBillingRun>>,
    { data?: PostSuperAdminBillingRunBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSuperAdminBillingRun(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminBillingRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminBillingRun>>
>
export type PostSuperAdminBillingRunMutationBody = PostSuperAdminBillingRunBody | undefined
export type PostSuperAdminBillingRunMutationError = unknown

/**
 * @summary Run billing for a month
 */
export const usePostSuperAdminBillingRun = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminBillingRun>>,
      TError,
      { data?: PostSuperAdminBillingRunBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminBillingRun>>,
  TError,
  { data?: PostSuperAdminBillingRunBody },
  TContext
> => {
  return useMutation(getPostSuperAdminBillingRunMutationOptions(options), queryClient)
}
export const getGetSuperAdminApiPricingUrl = () => {
  return `/api/v1/super-admin/api-pricing`
}

/**
 * @summary Every API pricing rule
 */
export const getSuperAdminApiPricing = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminApiPricing200> => {
  return customFetch<GetSuperAdminApiPricing200>(getGetSuperAdminApiPricingUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminApiPricingQueryKey = () => {
  return [`/api/v1/super-admin/api-pricing`] as const
}

export const getGetSuperAdminApiPricingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminApiPricing>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminApiPricing>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminApiPricingQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminApiPricing>>> = ({
    signal,
  }) => getSuperAdminApiPricing({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminApiPricing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminApiPricingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminApiPricing>>
>
export type GetSuperAdminApiPricingQueryError = unknown

export function useGetSuperAdminApiPricing<
  TData = Awaited<ReturnType<typeof getSuperAdminApiPricing>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminApiPricing>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminApiPricing>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminApiPricing>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminApiPricing<
  TData = Awaited<ReturnType<typeof getSuperAdminApiPricing>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminApiPricing>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminApiPricing>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminApiPricing>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminApiPricing<
  TData = Awaited<ReturnType<typeof getSuperAdminApiPricing>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminApiPricing>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every API pricing rule
 */

export function useGetSuperAdminApiPricing<
  TData = Awaited<ReturnType<typeof getSuperAdminApiPricing>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminApiPricing>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminApiPricingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSuperAdminApiPricingUrl = () => {
  return `/api/v1/super-admin/api-pricing`
}

/**
 * @summary Add an API pricing rule
 */
export const postSuperAdminApiPricing = async (
  postSuperAdminApiPricingBody?: PostSuperAdminApiPricingBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostSuperAdminApiPricing200> => {
  return customFetch<PostSuperAdminApiPricing200>(getPostSuperAdminApiPricingUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postSuperAdminApiPricingBody),
  })
}

export const getPostSuperAdminApiPricingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSuperAdminApiPricing>>,
    TError,
    { data?: PostSuperAdminApiPricingBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSuperAdminApiPricing>>,
  TError,
  { data?: PostSuperAdminApiPricingBody },
  TContext
> => {
  const mutationKey = ['postSuperAdminApiPricing']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSuperAdminApiPricing>>,
    { data?: PostSuperAdminApiPricingBody }
  > = (props) => {
    const { data } = props ?? {}

    return postSuperAdminApiPricing(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSuperAdminApiPricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSuperAdminApiPricing>>
>
export type PostSuperAdminApiPricingMutationBody = PostSuperAdminApiPricingBody | undefined
export type PostSuperAdminApiPricingMutationError = unknown

/**
 * @summary Add an API pricing rule
 */
export const usePostSuperAdminApiPricing = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSuperAdminApiPricing>>,
      TError,
      { data?: PostSuperAdminApiPricingBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSuperAdminApiPricing>>,
  TError,
  { data?: PostSuperAdminApiPricingBody },
  TContext
> => {
  return useMutation(getPostSuperAdminApiPricingMutationOptions(options), queryClient)
}
export const getPostPartnerAuthLoginUrl = () => {
  return `/api/v1/partner/auth/login`
}

/**
 * @summary Sign in to the partner portal
 */
export const postPartnerAuthLogin = async (
  postPartnerAuthLoginBody?: PostPartnerAuthLoginBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostPartnerAuthLogin200> => {
  return customFetch<PostPartnerAuthLogin200>(getPostPartnerAuthLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postPartnerAuthLoginBody),
  })
}

export const getPostPartnerAuthLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPartnerAuthLogin>>,
    TError,
    { data?: PostPartnerAuthLoginBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPartnerAuthLogin>>,
  TError,
  { data?: PostPartnerAuthLoginBody },
  TContext
> => {
  const mutationKey = ['postPartnerAuthLogin']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPartnerAuthLogin>>,
    { data?: PostPartnerAuthLoginBody }
  > = (props) => {
    const { data } = props ?? {}

    return postPartnerAuthLogin(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostPartnerAuthLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPartnerAuthLogin>>
>
export type PostPartnerAuthLoginMutationBody = PostPartnerAuthLoginBody | undefined
export type PostPartnerAuthLoginMutationError = unknown

/**
 * @summary Sign in to the partner portal
 */
export const usePostPartnerAuthLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPartnerAuthLogin>>,
      TError,
      { data?: PostPartnerAuthLoginBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPartnerAuthLogin>>,
  TError,
  { data?: PostPartnerAuthLoginBody },
  TContext
> => {
  return useMutation(getPostPartnerAuthLoginMutationOptions(options), queryClient)
}
export const getPostCentralFranchisesCacheInvalidateUrl = () => {
  return `/api/v1/central/franchises/cache/invalidate`
}

/**
 * @summary Forget the cached franchise configuration
 */
export const postCentralFranchisesCacheInvalidate = async (
  postCentralFranchisesCacheInvalidateBody?: PostCentralFranchisesCacheInvalidateBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostCentralFranchisesCacheInvalidate200> => {
  return customFetch<PostCentralFranchisesCacheInvalidate200>(
    getPostCentralFranchisesCacheInvalidateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(postCentralFranchisesCacheInvalidateBody),
    },
  )
}

export const getPostCentralFranchisesCacheInvalidateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCentralFranchisesCacheInvalidate>>,
    TError,
    { data?: PostCentralFranchisesCacheInvalidateBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCentralFranchisesCacheInvalidate>>,
  TError,
  { data?: PostCentralFranchisesCacheInvalidateBody },
  TContext
> => {
  const mutationKey = ['postCentralFranchisesCacheInvalidate']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCentralFranchisesCacheInvalidate>>,
    { data?: PostCentralFranchisesCacheInvalidateBody }
  > = (props) => {
    const { data } = props ?? {}

    return postCentralFranchisesCacheInvalidate(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCentralFranchisesCacheInvalidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCentralFranchisesCacheInvalidate>>
>
export type PostCentralFranchisesCacheInvalidateMutationBody =
  PostCentralFranchisesCacheInvalidateBody | undefined
export type PostCentralFranchisesCacheInvalidateMutationError = unknown

/**
 * @summary Forget the cached franchise configuration
 */
export const usePostCentralFranchisesCacheInvalidate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCentralFranchisesCacheInvalidate>>,
      TError,
      { data?: PostCentralFranchisesCacheInvalidateBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCentralFranchisesCacheInvalidate>>,
  TError,
  { data?: PostCentralFranchisesCacheInvalidateBody },
  TContext
> => {
  return useMutation(getPostCentralFranchisesCacheInvalidateMutationOptions(options), queryClient)
}
export const getPostCentralAuthLoginUrl = () => {
  return `/api/v1/central/auth/login`
}

/**
 * @summary Sign in as a platform super-admin
 */
export const postCentralAuthLogin = async (
  superAdminLoginRequest: SuperAdminLoginRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostCentralAuthLogin200> => {
  return customFetch<PostCentralAuthLogin200>(getPostCentralAuthLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(superAdminLoginRequest),
  })
}

export const getPostCentralAuthLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCentralAuthLogin>>,
    TError,
    { data: SuperAdminLoginRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCentralAuthLogin>>,
  TError,
  { data: SuperAdminLoginRequest },
  TContext
> => {
  const mutationKey = ['postCentralAuthLogin']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCentralAuthLogin>>,
    { data: SuperAdminLoginRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCentralAuthLogin(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCentralAuthLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCentralAuthLogin>>
>
export type PostCentralAuthLoginMutationBody = SuperAdminLoginRequest
export type PostCentralAuthLoginMutationError = unknown

/**
 * @summary Sign in as a platform super-admin
 */
export const usePostCentralAuthLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCentralAuthLogin>>,
      TError,
      { data: SuperAdminLoginRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCentralAuthLogin>>,
  TError,
  { data: SuperAdminLoginRequest },
  TContext
> => {
  return useMutation(getPostCentralAuthLoginMutationOptions(options), queryClient)
}
export const getDeleteSuperAdminPartnersIdUrl = (id: number) => {
  return `/api/v1/super-admin/partners/${id}`
}

/**
 * @summary Remove a partner
 */
export const deleteSuperAdminPartnersId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminPartnersId200> => {
  return customFetch<DeleteSuperAdminPartnersId200>(getDeleteSuperAdminPartnersIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSuperAdminPartnersIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminPartnersId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminPartnersId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminPartnersId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminPartnersId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSuperAdminPartnersId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminPartnersIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminPartnersId>>
>

export type DeleteSuperAdminPartnersIdMutationError = unknown

/**
 * @summary Remove a partner
 */
export const useDeleteSuperAdminPartnersId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminPartnersId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminPartnersId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSuperAdminPartnersIdMutationOptions(options), queryClient)
}
export const getPatchSuperAdminPartnersIdUrl = (id: number) => {
  return `/api/v1/super-admin/partners/${id}`
}

/**
 * @summary Update a partner
 */
export const patchSuperAdminPartnersId = async (
  id: number,
  patchSuperAdminPartnersIdBody?: PatchSuperAdminPartnersIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminPartnersId200> => {
  return customFetch<PatchSuperAdminPartnersId200>(getPatchSuperAdminPartnersIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSuperAdminPartnersIdBody),
  })
}

export const getPatchSuperAdminPartnersIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminPartnersId>>,
    TError,
    { id: number; data?: PatchSuperAdminPartnersIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminPartnersId>>,
  TError,
  { id: number; data?: PatchSuperAdminPartnersIdBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminPartnersId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminPartnersId>>,
    { id: number; data?: PatchSuperAdminPartnersIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSuperAdminPartnersId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminPartnersIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminPartnersId>>
>
export type PatchSuperAdminPartnersIdMutationBody = PatchSuperAdminPartnersIdBody | undefined
export type PatchSuperAdminPartnersIdMutationError = unknown

/**
 * @summary Update a partner
 */
export const usePatchSuperAdminPartnersId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminPartnersId>>,
      TError,
      { id: number; data?: PatchSuperAdminPartnersIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminPartnersId>>,
  TError,
  { id: number; data?: PatchSuperAdminPartnersIdBody },
  TContext
> => {
  return useMutation(getPatchSuperAdminPartnersIdMutationOptions(options), queryClient)
}
export const getDeleteSuperAdminPackagesPackageIdUrl = (packageId: number) => {
  return `/api/v1/super-admin/packages/${packageId}`
}

/**
 * @summary Remove a tier nobody is on
 */
export const deleteSuperAdminPackagesPackageId = async (
  packageId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminPackagesPackageId200> => {
  return customFetch<DeleteSuperAdminPackagesPackageId200>(
    getDeleteSuperAdminPackagesPackageIdUrl(packageId),
    {
      ...options,
      method: 'DELETE',
    },
  )
}

export const getDeleteSuperAdminPackagesPackageIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminPackagesPackageId>>,
    TError,
    { packageId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminPackagesPackageId>>,
  TError,
  { packageId: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminPackagesPackageId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminPackagesPackageId>>,
    { packageId: number }
  > = (props) => {
    const { packageId } = props ?? {}

    return deleteSuperAdminPackagesPackageId(packageId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminPackagesPackageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminPackagesPackageId>>
>

export type DeleteSuperAdminPackagesPackageIdMutationError = unknown

/**
 * @summary Remove a tier nobody is on
 */
export const useDeleteSuperAdminPackagesPackageId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminPackagesPackageId>>,
      TError,
      { packageId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminPackagesPackageId>>,
  TError,
  { packageId: number },
  TContext
> => {
  return useMutation(getDeleteSuperAdminPackagesPackageIdMutationOptions(options), queryClient)
}
export const getPatchSuperAdminPackagesPackageIdUrl = (packageId: number) => {
  return `/api/v1/super-admin/packages/${packageId}`
}

/**
 * @summary Rename, reprice or re-theme a tier
 */
export const patchSuperAdminPackagesPackageId = async (
  packageId: number,
  patchSuperAdminPackagesPackageIdBody: PatchSuperAdminPackagesPackageIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminPackagesPackageId200> => {
  return customFetch<PatchSuperAdminPackagesPackageId200>(
    getPatchSuperAdminPackagesPackageIdUrl(packageId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(patchSuperAdminPackagesPackageIdBody),
    },
  )
}

export const getPatchSuperAdminPackagesPackageIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminPackagesPackageId>>,
    TError,
    { packageId: number; data: PatchSuperAdminPackagesPackageIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminPackagesPackageId>>,
  TError,
  { packageId: number; data: PatchSuperAdminPackagesPackageIdBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminPackagesPackageId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminPackagesPackageId>>,
    { packageId: number; data: PatchSuperAdminPackagesPackageIdBody }
  > = (props) => {
    const { packageId, data } = props ?? {}

    return patchSuperAdminPackagesPackageId(packageId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminPackagesPackageIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminPackagesPackageId>>
>
export type PatchSuperAdminPackagesPackageIdMutationBody = PatchSuperAdminPackagesPackageIdBody
export type PatchSuperAdminPackagesPackageIdMutationError = unknown

/**
 * @summary Rename, reprice or re-theme a tier
 */
export const usePatchSuperAdminPackagesPackageId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminPackagesPackageId>>,
      TError,
      { packageId: number; data: PatchSuperAdminPackagesPackageIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminPackagesPackageId>>,
  TError,
  { packageId: number; data: PatchSuperAdminPackagesPackageIdBody },
  TContext
> => {
  return useMutation(getPatchSuperAdminPackagesPackageIdMutationOptions(options), queryClient)
}
export const getDeleteSuperAdminModuleBillingIdUrl = (id: number) => {
  return `/api/v1/super-admin/module-billing/${id}`
}

/**
 * @summary Remove a module charge
 */
export const deleteSuperAdminModuleBillingId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminModuleBillingId200> => {
  return customFetch<DeleteSuperAdminModuleBillingId200>(
    getDeleteSuperAdminModuleBillingIdUrl(id),
    {
      ...options,
      method: 'DELETE',
    },
  )
}

export const getDeleteSuperAdminModuleBillingIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminModuleBillingId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminModuleBillingId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminModuleBillingId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminModuleBillingId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSuperAdminModuleBillingId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminModuleBillingIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminModuleBillingId>>
>

export type DeleteSuperAdminModuleBillingIdMutationError = unknown

/**
 * @summary Remove a module charge
 */
export const useDeleteSuperAdminModuleBillingId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminModuleBillingId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminModuleBillingId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSuperAdminModuleBillingIdMutationOptions(options), queryClient)
}
export const getPatchSuperAdminModuleBillingIdUrl = (id: number) => {
  return `/api/v1/super-admin/module-billing/${id}`
}

/**
 * @summary Update a module charge
 */
export const patchSuperAdminModuleBillingId = async (
  id: number,
  patchSuperAdminModuleBillingIdBody?: PatchSuperAdminModuleBillingIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminModuleBillingId200> => {
  return customFetch<PatchSuperAdminModuleBillingId200>(getPatchSuperAdminModuleBillingIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSuperAdminModuleBillingIdBody),
  })
}

export const getPatchSuperAdminModuleBillingIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminModuleBillingId>>,
    TError,
    { id: number; data?: PatchSuperAdminModuleBillingIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminModuleBillingId>>,
  TError,
  { id: number; data?: PatchSuperAdminModuleBillingIdBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminModuleBillingId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminModuleBillingId>>,
    { id: number; data?: PatchSuperAdminModuleBillingIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSuperAdminModuleBillingId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminModuleBillingIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminModuleBillingId>>
>
export type PatchSuperAdminModuleBillingIdMutationBody =
  PatchSuperAdminModuleBillingIdBody | undefined
export type PatchSuperAdminModuleBillingIdMutationError = unknown

/**
 * @summary Update a module charge
 */
export const usePatchSuperAdminModuleBillingId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminModuleBillingId>>,
      TError,
      { id: number; data?: PatchSuperAdminModuleBillingIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminModuleBillingId>>,
  TError,
  { id: number; data?: PatchSuperAdminModuleBillingIdBody },
  TContext
> => {
  return useMutation(getPatchSuperAdminModuleBillingIdMutationOptions(options), queryClient)
}
export const getDeleteSuperAdminInvoicesIdUrl = (id: number) => {
  return `/api/v1/super-admin/invoices/${id}`
}

/**
 * @summary Delete an invoice
 */
export const deleteSuperAdminInvoicesId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminInvoicesId200> => {
  return customFetch<DeleteSuperAdminInvoicesId200>(getDeleteSuperAdminInvoicesIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSuperAdminInvoicesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminInvoicesId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminInvoicesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminInvoicesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminInvoicesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSuperAdminInvoicesId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminInvoicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminInvoicesId>>
>

export type DeleteSuperAdminInvoicesIdMutationError = unknown

/**
 * @summary Delete an invoice
 */
export const useDeleteSuperAdminInvoicesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminInvoicesId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminInvoicesId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSuperAdminInvoicesIdMutationOptions(options), queryClient)
}
export const getPatchSuperAdminInvoicesIdUrl = (id: number) => {
  return `/api/v1/super-admin/invoices/${id}`
}

/**
 * @summary Correct an invoice
 */
export const patchSuperAdminInvoicesId = async (
  id: number,
  patchSuperAdminInvoicesIdBody?: PatchSuperAdminInvoicesIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminInvoicesId200> => {
  return customFetch<PatchSuperAdminInvoicesId200>(getPatchSuperAdminInvoicesIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSuperAdminInvoicesIdBody),
  })
}

export const getPatchSuperAdminInvoicesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminInvoicesId>>,
    TError,
    { id: number; data?: PatchSuperAdminInvoicesIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminInvoicesId>>,
  TError,
  { id: number; data?: PatchSuperAdminInvoicesIdBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminInvoicesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminInvoicesId>>,
    { id: number; data?: PatchSuperAdminInvoicesIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSuperAdminInvoicesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminInvoicesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminInvoicesId>>
>
export type PatchSuperAdminInvoicesIdMutationBody = PatchSuperAdminInvoicesIdBody | undefined
export type PatchSuperAdminInvoicesIdMutationError = unknown

/**
 * @summary Correct an invoice
 */
export const usePatchSuperAdminInvoicesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminInvoicesId>>,
      TError,
      { id: number; data?: PatchSuperAdminInvoicesIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminInvoicesId>>,
  TError,
  { id: number; data?: PatchSuperAdminInvoicesIdBody },
  TContext
> => {
  return useMutation(getPatchSuperAdminInvoicesIdMutationOptions(options), queryClient)
}
export const getDeleteSuperAdminHardwareIdUrl = (id: number) => {
  return `/api/v1/super-admin/hardware/${id}`
}

/**
 * @summary Remove a hardware rental
 */
export const deleteSuperAdminHardwareId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminHardwareId200> => {
  return customFetch<DeleteSuperAdminHardwareId200>(getDeleteSuperAdminHardwareIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSuperAdminHardwareIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminHardwareId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminHardwareId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminHardwareId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminHardwareId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSuperAdminHardwareId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminHardwareIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminHardwareId>>
>

export type DeleteSuperAdminHardwareIdMutationError = unknown

/**
 * @summary Remove a hardware rental
 */
export const useDeleteSuperAdminHardwareId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminHardwareId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminHardwareId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSuperAdminHardwareIdMutationOptions(options), queryClient)
}
export const getPatchSuperAdminHardwareIdUrl = (id: number) => {
  return `/api/v1/super-admin/hardware/${id}`
}

/**
 * @summary Update a hardware rental
 */
export const patchSuperAdminHardwareId = async (
  id: number,
  patchSuperAdminHardwareIdBody?: PatchSuperAdminHardwareIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminHardwareId200> => {
  return customFetch<PatchSuperAdminHardwareId200>(getPatchSuperAdminHardwareIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSuperAdminHardwareIdBody),
  })
}

export const getPatchSuperAdminHardwareIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminHardwareId>>,
    TError,
    { id: number; data?: PatchSuperAdminHardwareIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminHardwareId>>,
  TError,
  { id: number; data?: PatchSuperAdminHardwareIdBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminHardwareId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminHardwareId>>,
    { id: number; data?: PatchSuperAdminHardwareIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSuperAdminHardwareId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminHardwareIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminHardwareId>>
>
export type PatchSuperAdminHardwareIdMutationBody = PatchSuperAdminHardwareIdBody | undefined
export type PatchSuperAdminHardwareIdMutationError = unknown

/**
 * @summary Update a hardware rental
 */
export const usePatchSuperAdminHardwareId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminHardwareId>>,
      TError,
      { id: number; data?: PatchSuperAdminHardwareIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminHardwareId>>,
  TError,
  { id: number; data?: PatchSuperAdminHardwareIdBody },
  TContext
> => {
  return useMutation(getPatchSuperAdminHardwareIdMutationOptions(options), queryClient)
}
export const getDeleteSuperAdminFranchisesFranchiseIdUrl = (
  franchiseId: number,
  params?: DeleteSuperAdminFranchisesFranchiseIdParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/super-admin/franchises/${franchiseId}?${stringifiedParams}`
    : `/api/v1/super-admin/franchises/${franchiseId}`
}

/**
 * @summary Retire a franchise
 */
export const deleteSuperAdminFranchisesFranchiseId = async (
  franchiseId: number,
  params?: DeleteSuperAdminFranchisesFranchiseIdParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminFranchisesFranchiseId200> => {
  return customFetch<DeleteSuperAdminFranchisesFranchiseId200>(
    getDeleteSuperAdminFranchisesFranchiseIdUrl(franchiseId, params),
    {
      ...options,
      method: 'DELETE',
    },
  )
}

export const getDeleteSuperAdminFranchisesFranchiseIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseId>>,
    TError,
    { franchiseId: number; params?: DeleteSuperAdminFranchisesFranchiseIdParams },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseId>>,
  TError,
  { franchiseId: number; params?: DeleteSuperAdminFranchisesFranchiseIdParams },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminFranchisesFranchiseId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseId>>,
    { franchiseId: number; params?: DeleteSuperAdminFranchisesFranchiseIdParams }
  > = (props) => {
    const { franchiseId, params } = props ?? {}

    return deleteSuperAdminFranchisesFranchiseId(franchiseId, params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminFranchisesFranchiseIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseId>>
>

export type DeleteSuperAdminFranchisesFranchiseIdMutationError = unknown

/**
 * @summary Retire a franchise
 */
export const useDeleteSuperAdminFranchisesFranchiseId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseId>>,
      TError,
      { franchiseId: number; params?: DeleteSuperAdminFranchisesFranchiseIdParams },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseId>>,
  TError,
  { franchiseId: number; params?: DeleteSuperAdminFranchisesFranchiseIdParams },
  TContext
> => {
  return useMutation(getDeleteSuperAdminFranchisesFranchiseIdMutationOptions(options), queryClient)
}
export const getPatchSuperAdminFranchisesFranchiseIdUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}`
}

/**
 * @summary Change a franchise
 */
export const patchSuperAdminFranchisesFranchiseId = async (
  franchiseId: number,
  patchSuperAdminFranchisesFranchiseIdBody: PatchSuperAdminFranchisesFranchiseIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminFranchisesFranchiseId200> => {
  return customFetch<PatchSuperAdminFranchisesFranchiseId200>(
    getPatchSuperAdminFranchisesFranchiseIdUrl(franchiseId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(patchSuperAdminFranchisesFranchiseIdBody),
    },
  )
}

export const getPatchSuperAdminFranchisesFranchiseIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseId>>,
    TError,
    { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseId>>,
  TError,
  { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminFranchisesFranchiseId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseId>>,
    { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdBody }
  > = (props) => {
    const { franchiseId, data } = props ?? {}

    return patchSuperAdminFranchisesFranchiseId(franchiseId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminFranchisesFranchiseIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseId>>
>
export type PatchSuperAdminFranchisesFranchiseIdMutationBody =
  PatchSuperAdminFranchisesFranchiseIdBody
export type PatchSuperAdminFranchisesFranchiseIdMutationError = unknown

/**
 * @summary Change a franchise
 */
export const usePatchSuperAdminFranchisesFranchiseId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseId>>,
      TError,
      { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseId>>,
  TError,
  { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdBody },
  TContext
> => {
  return useMutation(getPatchSuperAdminFranchisesFranchiseIdMutationOptions(options), queryClient)
}
export const getGetSuperAdminFranchisesFranchiseIdManagerSettingsUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/manager-settings`
}

/**
 * @summary Read a franchise's restaurant settings
 */
export const getSuperAdminFranchisesFranchiseIdManagerSettings = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdManagerSettings200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdManagerSettings200>(
    getGetSuperAdminFranchisesFranchiseIdManagerSettingsUrl(franchiseId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdManagerSettingsQueryKey = (
  franchiseId: number,
) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/manager-settings`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdManagerSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetSuperAdminFranchisesFranchiseIdManagerSettingsQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdManagerSettings(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdManagerSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>
>
export type GetSuperAdminFranchisesFranchiseIdManagerSettingsQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdManagerSettings<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdManagerSettings<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdManagerSettings<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read a franchise's restaurant settings
 */

export function useGetSuperAdminFranchisesFranchiseIdManagerSettings<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdManagerSettings>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdManagerSettingsQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchSuperAdminFranchisesFranchiseIdManagerSettingsUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/manager-settings`
}

/**
 * @summary Update a franchise's restaurant settings
 */
export const patchSuperAdminFranchisesFranchiseIdManagerSettings = async (
  franchiseId: number,
  patchSuperAdminFranchisesFranchiseIdManagerSettingsBody?: PatchSuperAdminFranchisesFranchiseIdManagerSettingsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminFranchisesFranchiseIdManagerSettings200> => {
  return customFetch<PatchSuperAdminFranchisesFranchiseIdManagerSettings200>(
    getPatchSuperAdminFranchisesFranchiseIdManagerSettingsUrl(franchiseId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(patchSuperAdminFranchisesFranchiseIdManagerSettingsBody),
    },
  )
}

export const getPatchSuperAdminFranchisesFranchiseIdManagerSettingsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdManagerSettings>>,
    TError,
    { franchiseId: number; data?: PatchSuperAdminFranchisesFranchiseIdManagerSettingsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdManagerSettings>>,
  TError,
  { franchiseId: number; data?: PatchSuperAdminFranchisesFranchiseIdManagerSettingsBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminFranchisesFranchiseIdManagerSettings']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdManagerSettings>>,
    { franchiseId: number; data?: PatchSuperAdminFranchisesFranchiseIdManagerSettingsBody }
  > = (props) => {
    const { franchiseId, data } = props ?? {}

    return patchSuperAdminFranchisesFranchiseIdManagerSettings(franchiseId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminFranchisesFranchiseIdManagerSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdManagerSettings>>
>
export type PatchSuperAdminFranchisesFranchiseIdManagerSettingsMutationBody =
  PatchSuperAdminFranchisesFranchiseIdManagerSettingsBody | undefined
export type PatchSuperAdminFranchisesFranchiseIdManagerSettingsMutationError = unknown

/**
 * @summary Update a franchise's restaurant settings
 */
export const usePatchSuperAdminFranchisesFranchiseIdManagerSettings = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdManagerSettings>>,
      TError,
      { franchiseId: number; data?: PatchSuperAdminFranchisesFranchiseIdManagerSettingsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdManagerSettings>>,
  TError,
  { franchiseId: number; data?: PatchSuperAdminFranchisesFranchiseIdManagerSettingsBody },
  TContext
> => {
  return useMutation(
    getPatchSuperAdminFranchisesFranchiseIdManagerSettingsMutationOptions(options),
    queryClient,
  )
}
export const getGetSuperAdminFranchisesFranchiseIdIntegrationsUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/integrations`
}

/**
 * @summary A franchise's integrations, with secrets reported as present or absent
 */
export const getSuperAdminFranchisesFranchiseIdIntegrations = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdIntegrations200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdIntegrations200>(
    getGetSuperAdminFranchisesFranchiseIdIntegrationsUrl(franchiseId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdIntegrationsQueryKey = (franchiseId: number) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/integrations`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdIntegrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSuperAdminFranchisesFranchiseIdIntegrationsQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdIntegrations(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdIntegrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>
>
export type GetSuperAdminFranchisesFranchiseIdIntegrationsQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdIntegrations<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdIntegrations<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdIntegrations<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A franchise's integrations, with secrets reported as present or absent
 */

export function useGetSuperAdminFranchisesFranchiseIdIntegrations<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdIntegrations>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdIntegrationsQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchSuperAdminFranchisesFranchiseIdIntegrationsUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/integrations`
}

/**
 * @summary Change a franchise's integrations
 */
export const patchSuperAdminFranchisesFranchiseIdIntegrations = async (
  franchiseId: number,
  patchSuperAdminFranchisesFranchiseIdIntegrationsBody: PatchSuperAdminFranchisesFranchiseIdIntegrationsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminFranchisesFranchiseIdIntegrations200> => {
  return customFetch<PatchSuperAdminFranchisesFranchiseIdIntegrations200>(
    getPatchSuperAdminFranchisesFranchiseIdIntegrationsUrl(franchiseId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(patchSuperAdminFranchisesFranchiseIdIntegrationsBody),
    },
  )
}

export const getPatchSuperAdminFranchisesFranchiseIdIntegrationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdIntegrations>>,
    TError,
    { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdIntegrationsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdIntegrations>>,
  TError,
  { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdIntegrationsBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminFranchisesFranchiseIdIntegrations']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdIntegrations>>,
    { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdIntegrationsBody }
  > = (props) => {
    const { franchiseId, data } = props ?? {}

    return patchSuperAdminFranchisesFranchiseIdIntegrations(franchiseId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminFranchisesFranchiseIdIntegrationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdIntegrations>>
>
export type PatchSuperAdminFranchisesFranchiseIdIntegrationsMutationBody =
  PatchSuperAdminFranchisesFranchiseIdIntegrationsBody
export type PatchSuperAdminFranchisesFranchiseIdIntegrationsMutationError = unknown

/**
 * @summary Change a franchise's integrations
 */
export const usePatchSuperAdminFranchisesFranchiseIdIntegrations = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdIntegrations>>,
      TError,
      { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdIntegrationsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdIntegrations>>,
  TError,
  { franchiseId: number; data: PatchSuperAdminFranchisesFranchiseIdIntegrationsBody },
  TContext
> => {
  return useMutation(
    getPatchSuperAdminFranchisesFranchiseIdIntegrationsMutationOptions(options),
    queryClient,
  )
}
export const getDeleteSuperAdminFranchisesFranchiseIdAdminsAdminIdUrl = (
  franchiseId: number,
  adminId: number,
) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/admins/${adminId}`
}

/**
 * @summary Deactivate an administrator
 */
export const deleteSuperAdminFranchisesFranchiseIdAdminsAdminId = async (
  franchiseId: number,
  adminId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminFranchisesFranchiseIdAdminsAdminId200> => {
  return customFetch<DeleteSuperAdminFranchisesFranchiseIdAdminsAdminId200>(
    getDeleteSuperAdminFranchisesFranchiseIdAdminsAdminIdUrl(franchiseId, adminId),
    {
      ...options,
      method: 'DELETE',
    },
  )
}

export const getDeleteSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
    TError,
    { franchiseId: number; adminId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
  TError,
  { franchiseId: number; adminId: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminFranchisesFranchiseIdAdminsAdminId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
    { franchiseId: number; adminId: number }
  > = (props) => {
    const { franchiseId, adminId } = props ?? {}

    return deleteSuperAdminFranchisesFranchiseIdAdminsAdminId(franchiseId, adminId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdAdminsAdminId>>
>

export type DeleteSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationError = unknown

/**
 * @summary Deactivate an administrator
 */
export const useDeleteSuperAdminFranchisesFranchiseIdAdminsAdminId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
      TError,
      { franchiseId: number; adminId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
  TError,
  { franchiseId: number; adminId: number },
  TContext
> => {
  return useMutation(
    getDeleteSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationOptions(options),
    queryClient,
  )
}
export const getPatchSuperAdminFranchisesFranchiseIdAdminsAdminIdUrl = (
  franchiseId: number,
  adminId: number,
) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/admins/${adminId}`
}

/**
 * @summary Change an administrator inside a franchise
 */
export const patchSuperAdminFranchisesFranchiseIdAdminsAdminId = async (
  franchiseId: number,
  adminId: number,
  patchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody: PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminFranchisesFranchiseIdAdminsAdminId200> => {
  return customFetch<PatchSuperAdminFranchisesFranchiseIdAdminsAdminId200>(
    getPatchSuperAdminFranchisesFranchiseIdAdminsAdminIdUrl(franchiseId, adminId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(patchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody),
    },
  )
}

export const getPatchSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
    TError,
    {
      franchiseId: number
      adminId: number
      data: PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody
    },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
  TError,
  {
    franchiseId: number
    adminId: number
    data: PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody
  },
  TContext
> => {
  const mutationKey = ['patchSuperAdminFranchisesFranchiseIdAdminsAdminId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
    {
      franchiseId: number
      adminId: number
      data: PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody
    }
  > = (props) => {
    const { franchiseId, adminId, data } = props ?? {}

    return patchSuperAdminFranchisesFranchiseIdAdminsAdminId(
      franchiseId,
      adminId,
      data,
      requestOptions,
    )
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdAdminsAdminId>>
>
export type PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationBody =
  PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody
export type PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationError = unknown

/**
 * @summary Change an administrator inside a franchise
 */
export const usePatchSuperAdminFranchisesFranchiseIdAdminsAdminId = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
      TError,
      {
        franchiseId: number
        adminId: number
        data: PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody
      },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminFranchisesFranchiseIdAdminsAdminId>>,
  TError,
  {
    franchiseId: number
    adminId: number
    data: PatchSuperAdminFranchisesFranchiseIdAdminsAdminIdBody
  },
  TContext
> => {
  return useMutation(
    getPatchSuperAdminFranchisesFranchiseIdAdminsAdminIdMutationOptions(options),
    queryClient,
  )
}
export const getDeleteSuperAdminApiPricingIdUrl = (id: number) => {
  return `/api/v1/super-admin/api-pricing/${id}`
}

/**
 * @summary Remove an API pricing rule
 */
export const deleteSuperAdminApiPricingId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminApiPricingId200> => {
  return customFetch<DeleteSuperAdminApiPricingId200>(getDeleteSuperAdminApiPricingIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSuperAdminApiPricingIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminApiPricingId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminApiPricingId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminApiPricingId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminApiPricingId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSuperAdminApiPricingId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminApiPricingIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminApiPricingId>>
>

export type DeleteSuperAdminApiPricingIdMutationError = unknown

/**
 * @summary Remove an API pricing rule
 */
export const useDeleteSuperAdminApiPricingId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminApiPricingId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminApiPricingId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSuperAdminApiPricingIdMutationOptions(options), queryClient)
}
export const getPatchSuperAdminApiPricingIdUrl = (id: number) => {
  return `/api/v1/super-admin/api-pricing/${id}`
}

/**
 * @summary Update an API pricing rule
 */
export const patchSuperAdminApiPricingId = async (
  id: number,
  patchSuperAdminApiPricingIdBody?: PatchSuperAdminApiPricingIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchSuperAdminApiPricingId200> => {
  return customFetch<PatchSuperAdminApiPricingId200>(getPatchSuperAdminApiPricingIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchSuperAdminApiPricingIdBody),
  })
}

export const getPatchSuperAdminApiPricingIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSuperAdminApiPricingId>>,
    TError,
    { id: number; data?: PatchSuperAdminApiPricingIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSuperAdminApiPricingId>>,
  TError,
  { id: number; data?: PatchSuperAdminApiPricingIdBody },
  TContext
> => {
  const mutationKey = ['patchSuperAdminApiPricingId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSuperAdminApiPricingId>>,
    { id: number; data?: PatchSuperAdminApiPricingIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchSuperAdminApiPricingId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSuperAdminApiPricingIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSuperAdminApiPricingId>>
>
export type PatchSuperAdminApiPricingIdMutationBody = PatchSuperAdminApiPricingIdBody | undefined
export type PatchSuperAdminApiPricingIdMutationError = unknown

/**
 * @summary Update an API pricing rule
 */
export const usePatchSuperAdminApiPricingId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSuperAdminApiPricingId>>,
      TError,
      { id: number; data?: PatchSuperAdminApiPricingIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSuperAdminApiPricingId>>,
  TError,
  { id: number; data?: PatchSuperAdminApiPricingIdBody },
  TContext
> => {
  return useMutation(getPatchSuperAdminApiPricingIdMutationOptions(options), queryClient)
}
export const getGetSuperAdminUsagePlatformUrl = (params?: GetSuperAdminUsagePlatformParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/super-admin/usage/platform?${stringifiedParams}`
    : `/api/v1/super-admin/usage/platform`
}

/**
 * @summary The same, across every franchise
 */
export const getSuperAdminUsagePlatform = async (
  params?: GetSuperAdminUsagePlatformParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminUsagePlatform200> => {
  return customFetch<GetSuperAdminUsagePlatform200>(getGetSuperAdminUsagePlatformUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminUsagePlatformQueryKey = (
  params?: GetSuperAdminUsagePlatformParams,
) => {
  return [`/api/v1/super-admin/usage/platform`, ...(params ? [params] : [])] as const
}

export const getGetSuperAdminUsagePlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>,
  TError = unknown,
>(
  params?: GetSuperAdminUsagePlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminUsagePlatformQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>> = ({
    signal,
  }) => getSuperAdminUsagePlatform(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminUsagePlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>
>
export type GetSuperAdminUsagePlatformQueryError = unknown

export function useGetSuperAdminUsagePlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>,
  TError = unknown,
>(
  params: undefined | GetSuperAdminUsagePlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminUsagePlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>,
  TError = unknown,
>(
  params?: GetSuperAdminUsagePlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminUsagePlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>,
  TError = unknown,
>(
  params?: GetSuperAdminUsagePlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The same, across every franchise
 */

export function useGetSuperAdminUsagePlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>,
  TError = unknown,
>(
  params?: GetSuperAdminUsagePlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminUsagePlatform>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminUsagePlatformQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminStatsPlatformUrl = () => {
  return `/api/v1/super-admin/stats/platform`
}

/**
 * @summary The platform's totals: franchises, revenue and tier mix
 */
export const getSuperAdminStatsPlatform = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminStatsPlatform200> => {
  return customFetch<GetSuperAdminStatsPlatform200>(getGetSuperAdminStatsPlatformUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminStatsPlatformQueryKey = () => {
  return [`/api/v1/super-admin/stats/platform`] as const
}

export const getGetSuperAdminStatsPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminStatsPlatformQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>> = ({
    signal,
  }) => getSuperAdminStatsPlatform({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminStatsPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>
>
export type GetSuperAdminStatsPlatformQueryError = unknown

export function useGetSuperAdminStatsPlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminStatsPlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminStatsPlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The platform's totals: franchises, revenue and tier mix
 */

export function useGetSuperAdminStatsPlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsPlatform>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminStatsPlatformQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminStatsFranchisesUrl = () => {
  return `/api/v1/super-admin/stats/franchises`
}

/**
 * @summary One row of figures per active franchise
 */
export const getSuperAdminStatsFranchises = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminStatsFranchises200> => {
  return customFetch<GetSuperAdminStatsFranchises200>(getGetSuperAdminStatsFranchisesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminStatsFranchisesQueryKey = () => {
  return [`/api/v1/super-admin/stats/franchises`] as const
}

export const getGetSuperAdminStatsFranchisesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminStatsFranchisesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>> = ({
    signal,
  }) => getSuperAdminStatsFranchises({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminStatsFranchisesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>
>
export type GetSuperAdminStatsFranchisesQueryError = unknown

export function useGetSuperAdminStatsFranchises<
  TData = Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminStatsFranchises<
  TData = Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminStatsFranchises<
  TData = Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One row of figures per active franchise
 */

export function useGetSuperAdminStatsFranchises<
  TData = Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminStatsFranchises>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminStatsFranchisesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminProfitabilityUrl = (params?: GetSuperAdminProfitabilityParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/super-admin/profitability?${stringifiedParams}`
    : `/api/v1/super-admin/profitability`
}

/**
 * @summary Revenue, cost and partner split per franchise
 */
export const getSuperAdminProfitability = async (
  params?: GetSuperAdminProfitabilityParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminProfitability200> => {
  return customFetch<GetSuperAdminProfitability200>(getGetSuperAdminProfitabilityUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminProfitabilityQueryKey = (
  params?: GetSuperAdminProfitabilityParams,
) => {
  return [`/api/v1/super-admin/profitability`, ...(params ? [params] : [])] as const
}

export const getGetSuperAdminProfitabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminProfitability>>,
  TError = unknown,
>(
  params?: GetSuperAdminProfitabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminProfitability>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminProfitabilityQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminProfitability>>> = ({
    signal,
  }) => getSuperAdminProfitability(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminProfitability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminProfitabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminProfitability>>
>
export type GetSuperAdminProfitabilityQueryError = unknown

export function useGetSuperAdminProfitability<
  TData = Awaited<ReturnType<typeof getSuperAdminProfitability>>,
  TError = unknown,
>(
  params: undefined | GetSuperAdminProfitabilityParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminProfitability>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminProfitability>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminProfitability>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminProfitability<
  TData = Awaited<ReturnType<typeof getSuperAdminProfitability>>,
  TError = unknown,
>(
  params?: GetSuperAdminProfitabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminProfitability>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminProfitability>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminProfitability>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminProfitability<
  TData = Awaited<ReturnType<typeof getSuperAdminProfitability>>,
  TError = unknown,
>(
  params?: GetSuperAdminProfitabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminProfitability>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Revenue, cost and partner split per franchise
 */

export function useGetSuperAdminProfitability<
  TData = Awaited<ReturnType<typeof getSuperAdminProfitability>>,
  TError = unknown,
>(
  params?: GetSuperAdminProfitabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminProfitability>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminProfitabilityQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminOnpremInstallerPlatformUrl = (platform: string) => {
  return `/api/v1/super-admin/onprem-installer/${platform}`
}

/**
 * @summary Download the on-premise WireGuard installer
 */
export const getSuperAdminOnpremInstallerPlatform = async (
  platform: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetSuperAdminOnpremInstallerPlatformUrl(platform), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminOnpremInstallerPlatformQueryKey = (platform: string) => {
  return [`/api/v1/super-admin/onprem-installer/${platform}`] as const
}

export const getGetSuperAdminOnpremInstallerPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
  TError = unknown,
>(
  platform: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSuperAdminOnpremInstallerPlatformQueryKey(platform)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>
  > = ({ signal }) => getSuperAdminOnpremInstallerPlatform(platform, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: platform !== null && platform !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminOnpremInstallerPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>
>
export type GetSuperAdminOnpremInstallerPlatformQueryError = unknown

export function useGetSuperAdminOnpremInstallerPlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
  TError = unknown,
>(
  platform: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminOnpremInstallerPlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
  TError = unknown,
>(
  platform: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminOnpremInstallerPlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
  TError = unknown,
>(
  platform: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download the on-premise WireGuard installer
 */

export function useGetSuperAdminOnpremInstallerPlatform<
  TData = Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
  TError = unknown,
>(
  platform: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminOnpremInstallerPlatform>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminOnpremInstallerPlatformQueryOptions(platform, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminModulesUrl = () => {
  return `/api/v1/super-admin/modules`
}

/**
 * `enforced` is true when an endpoint carries `@RequireModule` for that key, so a franchise whose tier excludes it is refused by the **server**. The rest gate the manager's sidebar only - typing the address still reaches the screen. Computed from the routing table at runtime rather than maintained by hand, because the figure in SAAS.md §3.17 went stale in four days.
 * @summary Every feature that can be sold
 */
export const getSuperAdminModules = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminModules200> => {
  return customFetch<GetSuperAdminModules200>(getGetSuperAdminModulesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminModulesQueryKey = () => {
  return [`/api/v1/super-admin/modules`] as const
}

export const getGetSuperAdminModulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminModules>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModules>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminModulesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminModules>>> = ({ signal }) =>
    getSuperAdminModules({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminModules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminModulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminModules>>
>
export type GetSuperAdminModulesQueryError = unknown

export function useGetSuperAdminModules<
  TData = Awaited<ReturnType<typeof getSuperAdminModules>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModules>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminModules>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminModules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminModules<
  TData = Awaited<ReturnType<typeof getSuperAdminModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModules>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminModules>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminModules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminModules<
  TData = Awaited<ReturnType<typeof getSuperAdminModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModules>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every feature that can be sold
 */

export function useGetSuperAdminModules<
  TData = Awaited<ReturnType<typeof getSuperAdminModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModules>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminModulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminModulesCatalogUrl = () => {
  return `/api/v1/super-admin/modules-catalog`
}

/**
 * @summary Every module that can be priced
 */
export const getSuperAdminModulesCatalog = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminModulesCatalog200> => {
  return customFetch<GetSuperAdminModulesCatalog200>(getGetSuperAdminModulesCatalogUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminModulesCatalogQueryKey = () => {
  return [`/api/v1/super-admin/modules-catalog`] as const
}

export const getGetSuperAdminModulesCatalogQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminModulesCatalogQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>> = ({
    signal,
  }) => getSuperAdminModulesCatalog({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminModulesCatalogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>
>
export type GetSuperAdminModulesCatalogQueryError = unknown

export function useGetSuperAdminModulesCatalog<
  TData = Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminModulesCatalog<
  TData = Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminModulesCatalog<
  TData = Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every module that can be priced
 */

export function useGetSuperAdminModulesCatalog<
  TData = Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminModulesCatalog>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminModulesCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminMarketingPagesUrl = () => {
  return `/api/v1/super-admin/marketing-pages`
}

/**
 * @summary Every marketing page, published or not
 */
export const getSuperAdminMarketingPages = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminMarketingPages200> => {
  return customFetch<GetSuperAdminMarketingPages200>(getGetSuperAdminMarketingPagesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminMarketingPagesQueryKey = () => {
  return [`/api/v1/super-admin/marketing-pages`] as const
}

export const getGetSuperAdminMarketingPagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPages>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminMarketingPagesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminMarketingPages>>> = ({
    signal,
  }) => getSuperAdminMarketingPages({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminMarketingPages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminMarketingPagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminMarketingPages>>
>
export type GetSuperAdminMarketingPagesQueryError = unknown

export function useGetSuperAdminMarketingPages<
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminMarketingPages>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminMarketingPages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminMarketingPages<
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminMarketingPages>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminMarketingPages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminMarketingPages<
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPages>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every marketing page, published or not
 */

export function useGetSuperAdminMarketingPages<
  TData = Awaited<ReturnType<typeof getSuperAdminMarketingPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminMarketingPages>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminMarketingPagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminInvoicesIdPdfUrl = (id: number) => {
  return `/api/v1/super-admin/invoices/${id}/pdf`
}

/**
 * @summary An invoice as a PDF
 */
export const getSuperAdminInvoicesIdPdf = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetSuperAdminInvoicesIdPdfUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminInvoicesIdPdfQueryKey = (id: number) => {
  return [`/api/v1/super-admin/invoices/${id}/pdf`] as const
}

export const getGetSuperAdminInvoicesIdPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminInvoicesIdPdfQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>> = ({
    signal,
  }) => getSuperAdminInvoicesIdPdf(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetSuperAdminInvoicesIdPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>
>
export type GetSuperAdminInvoicesIdPdfQueryError = unknown

export function useGetSuperAdminInvoicesIdPdf<
  TData = Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminInvoicesIdPdf<
  TData = Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminInvoicesIdPdf<
  TData = Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary An invoice as a PDF
 */

export function useGetSuperAdminInvoicesIdPdf<
  TData = Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminInvoicesIdPdf>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminInvoicesIdPdfQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminFranchisesFranchiseIdWireguardConfigUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/wireguard/config`
}

/**
 * @summary Download this franchise's WireGuard configuration
 */
export const getSuperAdminFranchisesFranchiseIdWireguardConfig = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetSuperAdminFranchisesFranchiseIdWireguardConfigUrl(franchiseId), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminFranchisesFranchiseIdWireguardConfigQueryKey = (
  franchiseId: number,
) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/wireguard/config`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdWireguardConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetSuperAdminFranchisesFranchiseIdWireguardConfigQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdWireguardConfig(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdWireguardConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>
>
export type GetSuperAdminFranchisesFranchiseIdWireguardConfigQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdWireguardConfig<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdWireguardConfig<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdWireguardConfig<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download this franchise's WireGuard configuration
 */

export function useGetSuperAdminFranchisesFranchiseIdWireguardConfig<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdWireguardConfig>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdWireguardConfigQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminFranchisesFranchiseIdUsageUrl = (
  franchiseId: number,
  params?: GetSuperAdminFranchisesFranchiseIdUsageParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/super-admin/franchises/${franchiseId}/usage?${stringifiedParams}`
    : `/api/v1/super-admin/franchises/${franchiseId}/usage`
}

/**
 * @summary What one franchise has spent on third-party calls
 */
export const getSuperAdminFranchisesFranchiseIdUsage = async (
  franchiseId: number,
  params?: GetSuperAdminFranchisesFranchiseIdUsageParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdUsage200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdUsage200>(
    getGetSuperAdminFranchisesFranchiseIdUsageUrl(franchiseId, params),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdUsageQueryKey = (
  franchiseId: number,
  params?: GetSuperAdminFranchisesFranchiseIdUsageParams,
) => {
  return [
    `/api/v1/super-admin/franchises/${franchiseId}/usage`,
    ...(params ? [params] : []),
  ] as const
}

export const getGetSuperAdminFranchisesFranchiseIdUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
  TError = unknown,
>(
  franchiseId: number,
  params?: GetSuperAdminFranchisesFranchiseIdUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetSuperAdminFranchisesFranchiseIdUsageQueryKey(franchiseId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdUsage(franchiseId, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>
>
export type GetSuperAdminFranchisesFranchiseIdUsageQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdUsage<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
  TError = unknown,
>(
  franchiseId: number,
  params: undefined | GetSuperAdminFranchisesFranchiseIdUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdUsage<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
  TError = unknown,
>(
  franchiseId: number,
  params?: GetSuperAdminFranchisesFranchiseIdUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdUsage<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
  TError = unknown,
>(
  franchiseId: number,
  params?: GetSuperAdminFranchisesFranchiseIdUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What one franchise has spent on third-party calls
 */

export function useGetSuperAdminFranchisesFranchiseIdUsage<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
  TError = unknown,
>(
  franchiseId: number,
  params?: GetSuperAdminFranchisesFranchiseIdUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdUsage>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdUsageQueryOptions(
    franchiseId,
    params,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminFranchisesFranchiseIdEffectiveModulesUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/effective-modules`
}

/**
 * @summary What a franchise can actually do, after all three layers
 */
export const getSuperAdminFranchisesFranchiseIdEffectiveModules = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdEffectiveModules200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdEffectiveModules200>(
    getGetSuperAdminFranchisesFranchiseIdEffectiveModulesUrl(franchiseId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdEffectiveModulesQueryKey = (
  franchiseId: number,
) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/effective-modules`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdEffectiveModulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetSuperAdminFranchisesFranchiseIdEffectiveModulesQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdEffectiveModules(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdEffectiveModulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>
>
export type GetSuperAdminFranchisesFranchiseIdEffectiveModulesQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdEffectiveModules<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdEffectiveModules<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdEffectiveModules<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What a franchise can actually do, after all three layers
 */

export function useGetSuperAdminFranchisesFranchiseIdEffectiveModules<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdEffectiveModules>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdEffectiveModulesQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminFranchisesFranchiseIdDomainsPlanUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/domains/plan`
}

/**
 * @summary What provisioning this franchise's domains would do
 */
export const getSuperAdminFranchisesFranchiseIdDomainsPlan = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminFranchisesFranchiseIdDomainsPlan200> => {
  return customFetch<GetSuperAdminFranchisesFranchiseIdDomainsPlan200>(
    getGetSuperAdminFranchisesFranchiseIdDomainsPlanUrl(franchiseId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetSuperAdminFranchisesFranchiseIdDomainsPlanQueryKey = (franchiseId: number) => {
  return [`/api/v1/super-admin/franchises/${franchiseId}/domains/plan`] as const
}

export const getGetSuperAdminFranchisesFranchiseIdDomainsPlanQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSuperAdminFranchisesFranchiseIdDomainsPlanQueryKey(franchiseId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>
  > = ({ signal }) =>
    getSuperAdminFranchisesFranchiseIdDomainsPlan(franchiseId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: franchiseId !== null && franchiseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminFranchisesFranchiseIdDomainsPlanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>
>
export type GetSuperAdminFranchisesFranchiseIdDomainsPlanQueryError = unknown

export function useGetSuperAdminFranchisesFranchiseIdDomainsPlan<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
  TError = unknown,
>(
  franchiseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdDomainsPlan<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminFranchisesFranchiseIdDomainsPlan<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What provisioning this franchise's domains would do
 */

export function useGetSuperAdminFranchisesFranchiseIdDomainsPlan<
  TData = Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
  TError = unknown,
>(
  franchiseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuperAdminFranchisesFranchiseIdDomainsPlan>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminFranchisesFranchiseIdDomainsPlanQueryOptions(
    franchiseId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminCardpayDailyUrl = (params?: GetSuperAdminCardpayDailyParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/super-admin/cardpay/daily?${stringifiedParams}`
    : `/api/v1/super-admin/cardpay/daily`
}

/**
 * @summary Daily card-payment margin per franchise
 */
export const getSuperAdminCardpayDaily = async (
  params?: GetSuperAdminCardpayDailyParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminCardpayDaily200> => {
  return customFetch<GetSuperAdminCardpayDaily200>(getGetSuperAdminCardpayDailyUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminCardpayDailyQueryKey = (params?: GetSuperAdminCardpayDailyParams) => {
  return [`/api/v1/super-admin/cardpay/daily`, ...(params ? [params] : [])] as const
}

export const getGetSuperAdminCardpayDailyQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>,
  TError = unknown,
>(
  params?: GetSuperAdminCardpayDailyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminCardpayDailyQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>> = ({
    signal,
  }) => getSuperAdminCardpayDaily(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminCardpayDailyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>
>
export type GetSuperAdminCardpayDailyQueryError = unknown

export function useGetSuperAdminCardpayDaily<
  TData = Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>,
  TError = unknown,
>(
  params: undefined | GetSuperAdminCardpayDailyParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminCardpayDaily<
  TData = Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>,
  TError = unknown,
>(
  params?: GetSuperAdminCardpayDailyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminCardpayDaily<
  TData = Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>,
  TError = unknown,
>(
  params?: GetSuperAdminCardpayDailyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Daily card-payment margin per franchise
 */

export function useGetSuperAdminCardpayDaily<
  TData = Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>,
  TError = unknown,
>(
  params?: GetSuperAdminCardpayDailyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminCardpayDaily>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminCardpayDailyQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminAuditLogUrl = (params?: GetSuperAdminAuditLogParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/super-admin/audit-log?${stringifiedParams}`
    : `/api/v1/super-admin/audit-log`
}

/**
 * @summary What the platform's administrators have been doing
 */
export const getSuperAdminAuditLog = async (
  params?: GetSuperAdminAuditLogParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminAuditLog200> => {
  return customFetch<GetSuperAdminAuditLog200>(getGetSuperAdminAuditLogUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminAuditLogQueryKey = (params?: GetSuperAdminAuditLogParams) => {
  return [`/api/v1/super-admin/audit-log`, ...(params ? [params] : [])] as const
}

export const getGetSuperAdminAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminAuditLog>>,
  TError = unknown,
>(
  params?: GetSuperAdminAuditLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAuditLog>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminAuditLogQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminAuditLog>>> = ({ signal }) =>
    getSuperAdminAuditLog(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminAuditLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminAuditLog>>
>
export type GetSuperAdminAuditLogQueryError = unknown

export function useGetSuperAdminAuditLog<
  TData = Awaited<ReturnType<typeof getSuperAdminAuditLog>>,
  TError = unknown,
>(
  params: undefined | GetSuperAdminAuditLogParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAuditLog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminAuditLog>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminAuditLog>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminAuditLog<
  TData = Awaited<ReturnType<typeof getSuperAdminAuditLog>>,
  TError = unknown,
>(
  params?: GetSuperAdminAuditLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAuditLog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminAuditLog>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminAuditLog>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminAuditLog<
  TData = Awaited<ReturnType<typeof getSuperAdminAuditLog>>,
  TError = unknown,
>(
  params?: GetSuperAdminAuditLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAuditLog>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the platform's administrators have been doing
 */

export function useGetSuperAdminAuditLog<
  TData = Awaited<ReturnType<typeof getSuperAdminAuditLog>>,
  TError = unknown,
>(
  params?: GetSuperAdminAuditLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAuditLog>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminAuditLogQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSuperAdminAdminsUrl = () => {
  return `/api/v1/super-admin/admins`
}

/**
 * @summary Every administrator across every active franchise
 */
export const getSuperAdminAdmins = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSuperAdminAdmins200Item[]> => {
  return customFetch<GetSuperAdminAdmins200Item[]>(getGetSuperAdminAdminsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSuperAdminAdminsQueryKey = () => {
  return [`/api/v1/super-admin/admins`] as const
}

export const getGetSuperAdminAdminsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSuperAdminAdminsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminAdmins>>> = ({ signal }) =>
    getSuperAdminAdmins({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuperAdminAdmins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminAdminsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuperAdminAdmins>>
>
export type GetSuperAdminAdminsQueryError = unknown

export function useGetSuperAdminAdmins<
  TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminAdmins>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminAdmins>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminAdmins<
  TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminAdmins>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminAdmins>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminAdmins<
  TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every administrator across every active franchise
 */

export function useGetSuperAdminAdmins<
  TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuperAdminAdminsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsLunchPublicUrl = (params?: GetSettingsLunchPublicParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/settings/lunch/public?${stringifiedParams}`
    : `/api/v1/settings/lunch/public`
}

/**
 * @summary The lunch menu, as the customer site reads it
 */
export const getSettingsLunchPublic = async (
  params?: GetSettingsLunchPublicParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetSettingsLunchPublic200> => {
  return customFetch<GetSettingsLunchPublic200>(getGetSettingsLunchPublicUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsLunchPublicQueryKey = (params?: GetSettingsLunchPublicParams) => {
  return [`/api/v1/settings/lunch/public`, ...(params ? [params] : [])] as const
}

export const getGetSettingsLunchPublicQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsLunchPublic>>,
  TError = unknown,
>(
  params?: GetSettingsLunchPublicParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunchPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsLunchPublicQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsLunchPublic>>> = ({ signal }) =>
    getSettingsLunchPublic(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsLunchPublic>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsLunchPublicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsLunchPublic>>
>
export type GetSettingsLunchPublicQueryError = unknown

export function useGetSettingsLunchPublic<
  TData = Awaited<ReturnType<typeof getSettingsLunchPublic>>,
  TError = unknown,
>(
  params: undefined | GetSettingsLunchPublicParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunchPublic>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsLunchPublic>>,
          TError,
          Awaited<ReturnType<typeof getSettingsLunchPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsLunchPublic<
  TData = Awaited<ReturnType<typeof getSettingsLunchPublic>>,
  TError = unknown,
>(
  params?: GetSettingsLunchPublicParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunchPublic>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsLunchPublic>>,
          TError,
          Awaited<ReturnType<typeof getSettingsLunchPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsLunchPublic<
  TData = Awaited<ReturnType<typeof getSettingsLunchPublic>>,
  TError = unknown,
>(
  params?: GetSettingsLunchPublicParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunchPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The lunch menu, as the customer site reads it
 */

export function useGetSettingsLunchPublic<
  TData = Awaited<ReturnType<typeof getSettingsLunchPublic>>,
  TError = unknown,
>(
  params?: GetSettingsLunchPublicParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsLunchPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsLunchPublicQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsFooterUrl = () => {
  return `/api/v1/settings/footer`
}

/**
 * @summary Everything the customer site's footer renders
 */
export const getSettingsFooter = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<FooterSettings> => {
  return customFetch<FooterSettings>(getGetSettingsFooterUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsFooterQueryKey = () => {
  return [`/api/v1/settings/footer`] as const
}

export const getGetSettingsFooterQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsFooter>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFooter>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsFooterQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsFooter>>> = ({ signal }) =>
    getSettingsFooter({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsFooter>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsFooterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsFooter>>
>
export type GetSettingsFooterQueryError = unknown

export function useGetSettingsFooter<
  TData = Awaited<ReturnType<typeof getSettingsFooter>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFooter>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsFooter>>,
          TError,
          Awaited<ReturnType<typeof getSettingsFooter>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsFooter<
  TData = Awaited<ReturnType<typeof getSettingsFooter>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFooter>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsFooter>>,
          TError,
          Awaited<ReturnType<typeof getSettingsFooter>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsFooter<
  TData = Awaited<ReturnType<typeof getSettingsFooter>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFooter>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everything the customer site's footer renders
 */

export function useGetSettingsFooter<
  TData = Awaited<ReturnType<typeof getSettingsFooter>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsFooter>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsFooterQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsBasicPublicUrl = () => {
  return `/api/v1/settings/basic-public`
}

/**
 * @summary The language settings the customer site may read
 */
export const getSettingsBasicPublic = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PublicLanguageSettings> => {
  return customFetch<PublicLanguageSettings>(getGetSettingsBasicPublicUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsBasicPublicQueryKey = () => {
  return [`/api/v1/settings/basic-public`] as const
}

export const getGetSettingsBasicPublicQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsBasicPublic>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasicPublic>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsBasicPublicQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsBasicPublic>>> = ({ signal }) =>
    getSettingsBasicPublic({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsBasicPublic>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsBasicPublicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsBasicPublic>>
>
export type GetSettingsBasicPublicQueryError = unknown

export function useGetSettingsBasicPublic<
  TData = Awaited<ReturnType<typeof getSettingsBasicPublic>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasicPublic>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsBasicPublic>>,
          TError,
          Awaited<ReturnType<typeof getSettingsBasicPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsBasicPublic<
  TData = Awaited<ReturnType<typeof getSettingsBasicPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasicPublic>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsBasicPublic>>,
          TError,
          Awaited<ReturnType<typeof getSettingsBasicPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsBasicPublic<
  TData = Awaited<ReturnType<typeof getSettingsBasicPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasicPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The language settings the customer site may read
 */

export function useGetSettingsBasicPublic<
  TData = Awaited<ReturnType<typeof getSettingsBasicPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsBasicPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsBasicPublicQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPartnerMeProfitabilityUrl = (params?: GetPartnerMeProfitabilityParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/partner/me/profitability?${stringifiedParams}`
    : `/api/v1/partner/me/profitability`
}

/**
 * @summary Billed revenue and this partner's share of it
 */
export const getPartnerMeProfitability = async (
  params?: GetPartnerMeProfitabilityParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetPartnerMeProfitability200> => {
  return customFetch<GetPartnerMeProfitability200>(getGetPartnerMeProfitabilityUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetPartnerMeProfitabilityQueryKey = (params?: GetPartnerMeProfitabilityParams) => {
  return [`/api/v1/partner/me/profitability`, ...(params ? [params] : [])] as const
}

export const getGetPartnerMeProfitabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerMeProfitability>>,
  TError = unknown,
>(
  params?: GetPartnerMeProfitabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeProfitability>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerMeProfitabilityQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerMeProfitability>>> = ({
    signal,
  }) => getPartnerMeProfitability(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerMeProfitability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerMeProfitabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerMeProfitability>>
>
export type GetPartnerMeProfitabilityQueryError = unknown

export function useGetPartnerMeProfitability<
  TData = Awaited<ReturnType<typeof getPartnerMeProfitability>>,
  TError = unknown,
>(
  params: undefined | GetPartnerMeProfitabilityParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeProfitability>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerMeProfitability>>,
          TError,
          Awaited<ReturnType<typeof getPartnerMeProfitability>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerMeProfitability<
  TData = Awaited<ReturnType<typeof getPartnerMeProfitability>>,
  TError = unknown,
>(
  params?: GetPartnerMeProfitabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeProfitability>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerMeProfitability>>,
          TError,
          Awaited<ReturnType<typeof getPartnerMeProfitability>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerMeProfitability<
  TData = Awaited<ReturnType<typeof getPartnerMeProfitability>>,
  TError = unknown,
>(
  params?: GetPartnerMeProfitabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeProfitability>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Billed revenue and this partner's share of it
 */

export function useGetPartnerMeProfitability<
  TData = Awaited<ReturnType<typeof getPartnerMeProfitability>>,
  TError = unknown,
>(
  params?: GetPartnerMeProfitabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeProfitability>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerMeProfitabilityQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPartnerMeInvoicesUrl = () => {
  return `/api/v1/partner/me/invoices`
}

/**
 * @summary Invoices raised against this partner's franchises
 */
export const getPartnerMeInvoices = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetPartnerMeInvoices200> => {
  return customFetch<GetPartnerMeInvoices200>(getGetPartnerMeInvoicesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetPartnerMeInvoicesQueryKey = () => {
  return [`/api/v1/partner/me/invoices`] as const
}

export const getGetPartnerMeInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerMeInvoices>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeInvoices>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerMeInvoicesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerMeInvoices>>> = ({ signal }) =>
    getPartnerMeInvoices({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerMeInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerMeInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerMeInvoices>>
>
export type GetPartnerMeInvoicesQueryError = unknown

export function useGetPartnerMeInvoices<
  TData = Awaited<ReturnType<typeof getPartnerMeInvoices>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeInvoices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerMeInvoices>>,
          TError,
          Awaited<ReturnType<typeof getPartnerMeInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerMeInvoices<
  TData = Awaited<ReturnType<typeof getPartnerMeInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeInvoices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerMeInvoices>>,
          TError,
          Awaited<ReturnType<typeof getPartnerMeInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerMeInvoices<
  TData = Awaited<ReturnType<typeof getPartnerMeInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeInvoices>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invoices raised against this partner's franchises
 */

export function useGetPartnerMeInvoices<
  TData = Awaited<ReturnType<typeof getPartnerMeInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeInvoices>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerMeInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPartnerMeFranchisesUrl = () => {
  return `/api/v1/partner/me/franchises`
}

/**
 * @summary The franchises this partner holds a share in
 */
export const getPartnerMeFranchises = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetPartnerMeFranchises200> => {
  return customFetch<GetPartnerMeFranchises200>(getGetPartnerMeFranchisesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetPartnerMeFranchisesQueryKey = () => {
  return [`/api/v1/partner/me/franchises`] as const
}

export const getGetPartnerMeFranchisesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerMeFranchises>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeFranchises>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerMeFranchisesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerMeFranchises>>> = ({ signal }) =>
    getPartnerMeFranchises({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerMeFranchises>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerMeFranchisesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartnerMeFranchises>>
>
export type GetPartnerMeFranchisesQueryError = unknown

export function useGetPartnerMeFranchises<
  TData = Awaited<ReturnType<typeof getPartnerMeFranchises>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeFranchises>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerMeFranchises>>,
          TError,
          Awaited<ReturnType<typeof getPartnerMeFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerMeFranchises<
  TData = Awaited<ReturnType<typeof getPartnerMeFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeFranchises>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerMeFranchises>>,
          TError,
          Awaited<ReturnType<typeof getPartnerMeFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerMeFranchises<
  TData = Awaited<ReturnType<typeof getPartnerMeFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeFranchises>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The franchises this partner holds a share in
 */

export function useGetPartnerMeFranchises<
  TData = Awaited<ReturnType<typeof getPartnerMeFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPartnerMeFranchises>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerMeFranchisesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPartnerAuthMeUrl = () => {
  return `/api/v1/partner/auth/me`
}

/**
 * @summary The signed-in partner
 */
export const getPartnerAuthMe = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetPartnerAuthMe200> => {
  return customFetch<GetPartnerAuthMe200>(getGetPartnerAuthMeUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetPartnerAuthMeQueryKey = () => {
  return [`/api/v1/partner/auth/me`] as const
}

export const getGetPartnerAuthMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartnerAuthMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerAuthMe>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPartnerAuthMeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerAuthMe>>> = ({ signal }) =>
    getPartnerAuthMe({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartnerAuthMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnerAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnerAuthMe>>>
export type GetPartnerAuthMeQueryError = unknown

export function useGetPartnerAuthMe<
  TData = Awaited<ReturnType<typeof getPartnerAuthMe>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerAuthMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getPartnerAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerAuthMe<
  TData = Awaited<ReturnType<typeof getPartnerAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerAuthMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnerAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getPartnerAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnerAuthMe<
  TData = Awaited<ReturnType<typeof getPartnerAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The signed-in partner
 */

export function useGetPartnerAuthMe<
  TData = Awaited<ReturnType<typeof getPartnerAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPartnerAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetMarketingUrl = () => {
  return `/api/v1/marketing`
}

/**
 * @summary The published marketing home page
 */
export const getMarketing = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetMarketing200> => {
  return customFetch<GetMarketing200>(getGetMarketingUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetMarketingQueryKey = () => {
  return [`/api/v1/marketing`] as const
}

export const getGetMarketingQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketing>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketing>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMarketingQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketing>>> = ({ signal }) =>
    getMarketing({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketing>>>
export type GetMarketingQueryError = unknown

export function useGetMarketing<TData = Awaited<ReturnType<typeof getMarketing>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketing>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketing>>,
          TError,
          Awaited<ReturnType<typeof getMarketing>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketing<TData = Awaited<ReturnType<typeof getMarketing>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketing>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketing>>,
          TError,
          Awaited<ReturnType<typeof getMarketing>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketing<TData = Awaited<ReturnType<typeof getMarketing>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketing>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The published marketing home page
 */

export function useGetMarketing<TData = Awaited<ReturnType<typeof getMarketing>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketing>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetMarketingSlugUrl = (slug: string) => {
  return `/api/v1/marketing/${slug}`
}

/**
 * @summary A published marketing page
 */
export const getMarketingSlug = async (
  slug: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetMarketingSlug200> => {
  return customFetch<GetMarketingSlug200>(getGetMarketingSlugUrl(slug), {
    ...options,
    method: 'GET',
  })
}

export const getGetMarketingSlugQueryKey = (slug: string) => {
  return [`/api/v1/marketing/${slug}`] as const
}

export const getGetMarketingSlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingSlug>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSlugQueryKey(slug)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSlug>>> = ({ signal }) =>
    getMarketingSlug(slug, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getMarketingSlug>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetMarketingSlugQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingSlug>>>
export type GetMarketingSlugQueryError = unknown

export function useGetMarketingSlug<
  TData = Awaited<ReturnType<typeof getMarketingSlug>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingSlug>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSlug>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSlug>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingSlug<
  TData = Awaited<ReturnType<typeof getMarketingSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingSlug>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSlug>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSlug>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingSlug<
  TData = Awaited<ReturnType<typeof getMarketingSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingSlug>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A published marketing page
 */

export function useGetMarketingSlug<
  TData = Awaited<ReturnType<typeof getMarketingSlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingSlug>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSlugQueryOptions(slug, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetFranchiseModulesUrl = () => {
  return `/api/v1/franchise/modules`
}

/**
 * @summary The modules this franchise has
 */
export const getFranchiseModules = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<FranchiseModulesResponse> => {
  return customFetch<FranchiseModulesResponse>(getGetFranchiseModulesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetFranchiseModulesQueryKey = () => {
  return [`/api/v1/franchise/modules`] as const
}

export const getGetFranchiseModulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFranchiseModules>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFranchiseModules>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFranchiseModulesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFranchiseModules>>> = ({ signal }) =>
    getFranchiseModules({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFranchiseModules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFranchiseModulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFranchiseModules>>
>
export type GetFranchiseModulesQueryError = unknown

export function useGetFranchiseModules<
  TData = Awaited<ReturnType<typeof getFranchiseModules>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFranchiseModules>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFranchiseModules>>,
          TError,
          Awaited<ReturnType<typeof getFranchiseModules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFranchiseModules<
  TData = Awaited<ReturnType<typeof getFranchiseModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFranchiseModules>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFranchiseModules>>,
          TError,
          Awaited<ReturnType<typeof getFranchiseModules>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFranchiseModules<
  TData = Awaited<ReturnType<typeof getFranchiseModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFranchiseModules>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The modules this franchise has
 */

export function useGetFranchiseModules<
  TData = Awaited<ReturnType<typeof getFranchiseModules>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFranchiseModules>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFranchiseModulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCentralFranchisesUrl = () => {
  return `/api/v1/central/franchises`
}

/**
 * @summary The active franchises
 */
export const getCentralFranchises = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<FranchiseSummary[]> => {
  return customFetch<FranchiseSummary[]>(getGetCentralFranchisesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCentralFranchisesQueryKey = () => {
  return [`/api/v1/central/franchises`] as const
}

export const getGetCentralFranchisesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCentralFranchises>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchises>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCentralFranchisesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCentralFranchises>>> = ({ signal }) =>
    getCentralFranchises({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCentralFranchises>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCentralFranchisesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCentralFranchises>>
>
export type GetCentralFranchisesQueryError = unknown

export function useGetCentralFranchises<
  TData = Awaited<ReturnType<typeof getCentralFranchises>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchises>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralFranchises>>,
          TError,
          Awaited<ReturnType<typeof getCentralFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralFranchises<
  TData = Awaited<ReturnType<typeof getCentralFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchises>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralFranchises>>,
          TError,
          Awaited<ReturnType<typeof getCentralFranchises>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralFranchises<
  TData = Awaited<ReturnType<typeof getCentralFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchises>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The active franchises
 */

export function useGetCentralFranchises<
  TData = Awaited<ReturnType<typeof getCentralFranchises>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchises>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCentralFranchisesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCentralFranchisesDiscoverUrl = () => {
  return `/api/v1/central/franchises/discover`
}

/**
 * @summary The franchise catalogue, with routing and branding
 */
export const getCentralFranchisesDiscover = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetCentralFranchisesDiscover200Item[]> => {
  return customFetch<GetCentralFranchisesDiscover200Item[]>(getGetCentralFranchisesDiscoverUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCentralFranchisesDiscoverQueryKey = () => {
  return [`/api/v1/central/franchises/discover`] as const
}

export const getGetCentralFranchisesDiscoverQueryOptions = <
  TData = Awaited<ReturnType<typeof getCentralFranchisesDiscover>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchisesDiscover>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCentralFranchisesDiscoverQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCentralFranchisesDiscover>>> = ({
    signal,
  }) => getCentralFranchisesDiscover({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCentralFranchisesDiscover>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCentralFranchisesDiscoverQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCentralFranchisesDiscover>>
>
export type GetCentralFranchisesDiscoverQueryError = unknown

export function useGetCentralFranchisesDiscover<
  TData = Awaited<ReturnType<typeof getCentralFranchisesDiscover>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchisesDiscover>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralFranchisesDiscover>>,
          TError,
          Awaited<ReturnType<typeof getCentralFranchisesDiscover>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralFranchisesDiscover<
  TData = Awaited<ReturnType<typeof getCentralFranchisesDiscover>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchisesDiscover>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralFranchisesDiscover>>,
          TError,
          Awaited<ReturnType<typeof getCentralFranchisesDiscover>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralFranchisesDiscover<
  TData = Awaited<ReturnType<typeof getCentralFranchisesDiscover>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchisesDiscover>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The franchise catalogue, with routing and branding
 */

export function useGetCentralFranchisesDiscover<
  TData = Awaited<ReturnType<typeof getCentralFranchisesDiscover>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralFranchisesDiscover>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCentralFranchisesDiscoverQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCentralConfigUrl = () => {
  return `/api/v1/central/config`
}

/**
 * @summary Stack-wide flags the login screens read
 */
export const getCentralConfig = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetCentralConfig200> => {
  return customFetch<GetCentralConfig200>(getGetCentralConfigUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCentralConfigQueryKey = () => {
  return [`/api/v1/central/config`] as const
}

export const getGetCentralConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getCentralConfig>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralConfig>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCentralConfigQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCentralConfig>>> = ({ signal }) =>
    getCentralConfig({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCentralConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCentralConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getCentralConfig>>>
export type GetCentralConfigQueryError = unknown

export function useGetCentralConfig<
  TData = Awaited<ReturnType<typeof getCentralConfig>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralConfig>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralConfig>>,
          TError,
          Awaited<ReturnType<typeof getCentralConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralConfig<
  TData = Awaited<ReturnType<typeof getCentralConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralConfig>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralConfig>>,
          TError,
          Awaited<ReturnType<typeof getCentralConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralConfig<
  TData = Awaited<ReturnType<typeof getCentralConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralConfig>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stack-wide flags the login screens read
 */

export function useGetCentralConfig<
  TData = Awaited<ReturnType<typeof getCentralConfig>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralConfig>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCentralConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCentralBrandingUrl = (params?: GetCentralBrandingParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/central/branding?${stringifiedParams}`
    : `/api/v1/central/branding`
}

/**
 * @summary Whose site this is, and what it should look like
 */
export const getCentralBranding = async (
  params?: GetCentralBrandingParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Branding> => {
  return customFetch<Branding>(getGetCentralBrandingUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCentralBrandingQueryKey = (params?: GetCentralBrandingParams) => {
  return [`/api/v1/central/branding`, ...(params ? [params] : [])] as const
}

export const getGetCentralBrandingQueryOptions = <
  TData = Awaited<ReturnType<typeof getCentralBranding>>,
  TError = unknown,
>(
  params?: GetCentralBrandingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralBranding>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCentralBrandingQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCentralBranding>>> = ({ signal }) =>
    getCentralBranding(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCentralBranding>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCentralBrandingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCentralBranding>>
>
export type GetCentralBrandingQueryError = unknown

export function useGetCentralBranding<
  TData = Awaited<ReturnType<typeof getCentralBranding>>,
  TError = unknown,
>(
  params: undefined | GetCentralBrandingParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralBranding>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralBranding>>,
          TError,
          Awaited<ReturnType<typeof getCentralBranding>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralBranding<
  TData = Awaited<ReturnType<typeof getCentralBranding>>,
  TError = unknown,
>(
  params?: GetCentralBrandingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralBranding>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralBranding>>,
          TError,
          Awaited<ReturnType<typeof getCentralBranding>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralBranding<
  TData = Awaited<ReturnType<typeof getCentralBranding>>,
  TError = unknown,
>(
  params?: GetCentralBrandingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralBranding>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whose site this is, and what it should look like
 */

export function useGetCentralBranding<
  TData = Awaited<ReturnType<typeof getCentralBranding>>,
  TError = unknown,
>(
  params?: GetCentralBrandingParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralBranding>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCentralBrandingQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCentralBranchesUrl = (params?: GetCentralBranchesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/central/branches?${stringifiedParams}`
    : `/api/v1/central/branches`
}

/**
 * @summary The branches a customer may switch between
 */
export const getCentralBranches = async (
  params?: GetCentralBranchesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetCentralBranches200> => {
  return customFetch<GetCentralBranches200>(getGetCentralBranchesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCentralBranchesQueryKey = (params?: GetCentralBranchesParams) => {
  return [`/api/v1/central/branches`, ...(params ? [params] : [])] as const
}

export const getGetCentralBranchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCentralBranches>>,
  TError = unknown,
>(
  params?: GetCentralBranchesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralBranches>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCentralBranchesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCentralBranches>>> = ({ signal }) =>
    getCentralBranches(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCentralBranches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCentralBranchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCentralBranches>>
>
export type GetCentralBranchesQueryError = unknown

export function useGetCentralBranches<
  TData = Awaited<ReturnType<typeof getCentralBranches>>,
  TError = unknown,
>(
  params: undefined | GetCentralBranchesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralBranches>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralBranches>>,
          TError,
          Awaited<ReturnType<typeof getCentralBranches>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralBranches<
  TData = Awaited<ReturnType<typeof getCentralBranches>>,
  TError = unknown,
>(
  params?: GetCentralBranchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralBranches>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralBranches>>,
          TError,
          Awaited<ReturnType<typeof getCentralBranches>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralBranches<
  TData = Awaited<ReturnType<typeof getCentralBranches>>,
  TError = unknown,
>(
  params?: GetCentralBranchesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralBranches>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The branches a customer may switch between
 */

export function useGetCentralBranches<
  TData = Awaited<ReturnType<typeof getCentralBranches>>,
  TError = unknown,
>(
  params?: GetCentralBranchesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralBranches>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCentralBranchesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCentralBranchOptionsUrl = (params?: GetCentralBranchOptionsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/central/branch-options?${stringifiedParams}`
    : `/api/v1/central/branch-options`
}

/**
 * @summary The branches this login page may sign into
 */
export const getCentralBranchOptions = async (
  params?: GetCentralBranchOptionsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<BranchOptions> => {
  return customFetch<BranchOptions>(getGetCentralBranchOptionsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCentralBranchOptionsQueryKey = (params?: GetCentralBranchOptionsParams) => {
  return [`/api/v1/central/branch-options`, ...(params ? [params] : [])] as const
}

export const getGetCentralBranchOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCentralBranchOptions>>,
  TError = unknown,
>(
  params?: GetCentralBranchOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralBranchOptions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCentralBranchOptionsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCentralBranchOptions>>> = ({
    signal,
  }) => getCentralBranchOptions(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCentralBranchOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCentralBranchOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCentralBranchOptions>>
>
export type GetCentralBranchOptionsQueryError = unknown

export function useGetCentralBranchOptions<
  TData = Awaited<ReturnType<typeof getCentralBranchOptions>>,
  TError = unknown,
>(
  params: undefined | GetCentralBranchOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralBranchOptions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralBranchOptions>>,
          TError,
          Awaited<ReturnType<typeof getCentralBranchOptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralBranchOptions<
  TData = Awaited<ReturnType<typeof getCentralBranchOptions>>,
  TError = unknown,
>(
  params?: GetCentralBranchOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralBranchOptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralBranchOptions>>,
          TError,
          Awaited<ReturnType<typeof getCentralBranchOptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralBranchOptions<
  TData = Awaited<ReturnType<typeof getCentralBranchOptions>>,
  TError = unknown,
>(
  params?: GetCentralBranchOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralBranchOptions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The branches this login page may sign into
 */

export function useGetCentralBranchOptions<
  TData = Awaited<ReturnType<typeof getCentralBranchOptions>>,
  TError = unknown,
>(
  params?: GetCentralBranchOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCentralBranchOptions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCentralBranchOptionsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCentralAuthMeUrl = () => {
  return `/api/v1/central/auth/me`
}

/**
 * @summary The signed-in super-admin
 */
export const getCentralAuthMe = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetCentralAuthMe200> => {
  return customFetch<GetCentralAuthMe200>(getGetCentralAuthMeUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCentralAuthMeQueryKey = () => {
  return [`/api/v1/central/auth/me`] as const
}

export const getGetCentralAuthMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getCentralAuthMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralAuthMe>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCentralAuthMeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCentralAuthMe>>> = ({ signal }) =>
    getCentralAuthMe({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCentralAuthMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCentralAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getCentralAuthMe>>>
export type GetCentralAuthMeQueryError = unknown

export function useGetCentralAuthMe<
  TData = Awaited<ReturnType<typeof getCentralAuthMe>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralAuthMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getCentralAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralAuthMe<
  TData = Awaited<ReturnType<typeof getCentralAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralAuthMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCentralAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getCentralAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCentralAuthMe<
  TData = Awaited<ReturnType<typeof getCentralAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The signed-in super-admin
 */

export function useGetCentralAuthMe<
  TData = Awaited<ReturnType<typeof getCentralAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCentralAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCentralAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApiManifestWebmanifestUrl = (params?: GetApiManifestWebmanifestParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/manifest.webmanifest?${stringifiedParams}`
    : `/api/manifest.webmanifest`
}

/**
 * @summary The PWA manifest for this franchise
 */
export const getApiManifestWebmanifest = async (
  params?: GetApiManifestWebmanifestParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetApiManifestWebmanifest200> => {
  return customFetch<GetApiManifestWebmanifest200>(getGetApiManifestWebmanifestUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetApiManifestWebmanifestQueryKey = (params?: GetApiManifestWebmanifestParams) => {
  return [`/api/manifest.webmanifest`, ...(params ? [params] : [])] as const
}

export const getGetApiManifestWebmanifestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiManifestWebmanifest>>,
  TError = unknown,
>(
  params?: GetApiManifestWebmanifestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiManifestWebmanifest>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApiManifestWebmanifestQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiManifestWebmanifest>>> = ({
    signal,
  }) => getApiManifestWebmanifest(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiManifestWebmanifest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiManifestWebmanifestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiManifestWebmanifest>>
>
export type GetApiManifestWebmanifestQueryError = unknown

export function useGetApiManifestWebmanifest<
  TData = Awaited<ReturnType<typeof getApiManifestWebmanifest>>,
  TError = unknown,
>(
  params: undefined | GetApiManifestWebmanifestParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiManifestWebmanifest>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiManifestWebmanifest>>,
          TError,
          Awaited<ReturnType<typeof getApiManifestWebmanifest>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiManifestWebmanifest<
  TData = Awaited<ReturnType<typeof getApiManifestWebmanifest>>,
  TError = unknown,
>(
  params?: GetApiManifestWebmanifestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiManifestWebmanifest>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiManifestWebmanifest>>,
          TError,
          Awaited<ReturnType<typeof getApiManifestWebmanifest>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiManifestWebmanifest<
  TData = Awaited<ReturnType<typeof getApiManifestWebmanifest>>,
  TError = unknown,
>(
  params?: GetApiManifestWebmanifestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiManifestWebmanifest>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The PWA manifest for this franchise
 */

export function useGetApiManifestWebmanifest<
  TData = Awaited<ReturnType<typeof getApiManifestWebmanifest>>,
  TError = unknown,
>(
  params?: GetApiManifestWebmanifestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiManifestWebmanifest>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiManifestWebmanifestQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteSuperAdminFranchisesFranchiseIdWireguardUrl = (franchiseId: number) => {
  return `/api/v1/super-admin/franchises/${franchiseId}/wireguard`
}

/**
 * @summary Remove this franchise's WireGuard peer
 */
export const deleteSuperAdminFranchisesFranchiseIdWireguard = async (
  franchiseId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminFranchisesFranchiseIdWireguard200> => {
  return customFetch<DeleteSuperAdminFranchisesFranchiseIdWireguard200>(
    getDeleteSuperAdminFranchisesFranchiseIdWireguardUrl(franchiseId),
    {
      ...options,
      method: 'DELETE',
    },
  )
}

export const getDeleteSuperAdminFranchisesFranchiseIdWireguardMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdWireguard>>,
    TError,
    { franchiseId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdWireguard>>,
  TError,
  { franchiseId: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminFranchisesFranchiseIdWireguard']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdWireguard>>,
    { franchiseId: number }
  > = (props) => {
    const { franchiseId } = props ?? {}

    return deleteSuperAdminFranchisesFranchiseIdWireguard(franchiseId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminFranchisesFranchiseIdWireguardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdWireguard>>
>

export type DeleteSuperAdminFranchisesFranchiseIdWireguardMutationError = unknown

/**
 * @summary Remove this franchise's WireGuard peer
 */
export const useDeleteSuperAdminFranchisesFranchiseIdWireguard = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdWireguard>>,
      TError,
      { franchiseId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisesFranchiseIdWireguard>>,
  TError,
  { franchiseId: number },
  TContext
> => {
  return useMutation(
    getDeleteSuperAdminFranchisesFranchiseIdWireguardMutationOptions(options),
    queryClient,
  )
}
export const getDeleteSuperAdminFranchisePartnersIdUrl = (id: number) => {
  return `/api/v1/super-admin/franchise-partners/${id}`
}

/**
 * @summary Remove a partner's share in a franchise
 */
export const deleteSuperAdminFranchisePartnersId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteSuperAdminFranchisePartnersId200> => {
  return customFetch<DeleteSuperAdminFranchisePartnersId200>(
    getDeleteSuperAdminFranchisePartnersIdUrl(id),
    {
      ...options,
      method: 'DELETE',
    },
  )
}

export const getDeleteSuperAdminFranchisePartnersIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSuperAdminFranchisePartnersId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisePartnersId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteSuperAdminFranchisePartnersId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSuperAdminFranchisePartnersId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteSuperAdminFranchisePartnersId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSuperAdminFranchisePartnersIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisePartnersId>>
>

export type DeleteSuperAdminFranchisePartnersIdMutationError = unknown

/**
 * @summary Remove a partner's share in a franchise
 */
export const useDeleteSuperAdminFranchisePartnersId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSuperAdminFranchisePartnersId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSuperAdminFranchisePartnersId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSuperAdminFranchisePartnersIdMutationOptions(options), queryClient)
}
